/* eslint-disable */

import React from 'react';
import paper from 'paper';
import QuickSettings from 'quicksettings';

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { default: e };
}

const React__default = /* #__PURE__ */ _interopDefaultLegacy(React);
const paper__default = /* #__PURE__ */ _interopDefaultLegacy(paper);
const QuickSettings__default = /* #__PURE__ */ _interopDefaultLegacy(QuickSettings);

function _typeof(obj) {
  '@babel/helpers - typeof';

  return (
    (_typeof =
      typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
        ? function (obj) {
            return typeof obj;
          }
        : function (obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          }),
    _typeof(obj)
  );
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (let i = 0; i < props.length; i++) {
    const descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', {
    writable: false,
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true,
    },
  });
  Object.defineProperty(subClass, 'prototype', {
    writable: false,
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], () => {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      const a = [null];
      a.push.apply(a, args);
      const Constructor = Function.bind.apply(Parent, a);
      const instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(`this hasn't been initialised - super() hasn't been called`);
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === 'object' || typeof call === 'function')) {
    return call;
  }
  if (call !== void 0) {
    throw new TypeError('Derived constructors may only return object or undefined');
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  const hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    const Super = _getPrototypeOf(Derived);
    let result;

    if (hasNativeReflectConstruct) {
      const NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== 'undefined' && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      const base = _superPropBase(target, property);

      if (!base) return;
      const desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  let n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  let it = (typeof Symbol !== 'undefined' && o[Symbol.iterator]) || o['@@iterator'];

  if (!it) {
    if (
      Array.isArray(o) ||
      (it = _unsupportedIterableToArray(o)) ||
      (allowArrayLike && o && typeof o.length === 'number')
    ) {
      if (it) o = it;
      let i = 0;

      const F = function () {};

      return {
        s: F,
        n() {
          if (i >= o.length)
            return {
              done: true,
            };
          return {
            done: false,
            value: o[i++],
          };
        },
        e(e) {
          throw e;
        },
        f: F,
      };
    }

    throw new TypeError(
      'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
    );
  }

  let normalCompletion = true;
  let didErr = false;
  let err;
  return {
    s() {
      it = it.call(o);
    },
    n() {
      const step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e(e) {
      didErr = true;
      err = e;
    },
    f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    },
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED 'AS IS' AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from) {
  for (let i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
}

let _a$1;
let _b;

// Convert TypeScript enums to ES module constants
const AromaType = {
  Fruity: 'Fruity',
  Citrus: 'Citrus',
  Floral: 'Floral',
  Green: 'Green',
  Herbal: 'Herbal',
  Vegetable: 'Vegetable',
  Caramel: 'Caramel',
  Roasted: 'Roasted',
  Nutty: 'Nutty',
  Woody: 'Woody',
  Spicy: 'Spicy',
  Cheesy: 'Cheesy',
  Animal: 'Animal',
  Chemical: 'Chemical', // Odorless = 'Odorless', // currently ignored
};

const AromaDotState = {
  Absent: 'Absent',
  ExistsNotShared: 'ExistsNotShared',
  ExistsShared: 'ExistsShared',
};

const AromaTypesArray = [
  AromaType.Fruity,
  AromaType.Citrus,
  AromaType.Floral,
  AromaType.Green,
  AromaType.Herbal,
  AromaType.Vegetable,
  AromaType.Caramel,
  AromaType.Roasted,
  AromaType.Nutty,
  AromaType.Woody,
  AromaType.Spicy,
  AromaType.Cheesy,
  AromaType.Animal,
  AromaType.Chemical,
];
const AromaColorMapping =
  ((_a$1 = {}),
  (_a$1[AromaType.Fruity] = '#FFB600'),
  (_a$1[AromaType.Citrus] = '#CEDC2F'),
  (_a$1[AromaType.Floral] = '#941C81'),
  (_a$1[AromaType.Green] = '#009C4A'),
  (_a$1[AromaType.Herbal] = '#377F8F'),
  (_a$1[AromaType.Vegetable] = '#8DC63F'),
  (_a$1[AromaType.Caramel] = '#DC6A02'),
  (_a$1[AromaType.Roasted] = '#673325'),
  (_a$1[AromaType.Nutty] = '#D4A614'),
  (_a$1[AromaType.Woody] = '#9E4915'),
  (_a$1[AromaType.Spicy] = '#EF4123'),
  (_a$1[AromaType.Cheesy] = '#FFCB05'),
  (_a$1[AromaType.Animal] = '#AD274E'),
  (_a$1[AromaType.Chemical] = '#555951'), // [AromaType.Odorless]: 'rgb(255, 255, 255)',
  (_a$1[AromaDotState.Absent] = 'rgb(0, 0, 0)'),
  _a$1);
const AromaDotStateSizeMapping =
  ((_b = {}),
  (_b[AromaDotState.Absent] = 8),
  (_b[AromaDotState.ExistsNotShared] = 20),
  (_b[AromaDotState.ExistsShared] = 46),
  _b);

function getDotProperty(aroma, state) {
  return {
    color: AromaColorMapping[state === AromaDotState.Absent ? AromaDotState.Absent : aroma],
    size: AromaDotStateSizeMapping[state],
  };
}
function calculateTextWidth(text, font) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (context) {
    context.font = font || `18px 'Helvetica'`;
    return context.measureText(text).width;
  }

  return 0;
}

const DotGraphVizRow = function DotGraphVizRow(_a) {
  const { cellWidth } = _a;
  const { ingredient } = _a;
  const { initialOffsetX } = _a;
  const { fontSize } = _a;
  const { fontFamily } = _a;
  const { fontColor } = _a;
  const { offsetY } = _a;
  const { showIngredientTitle } = _a;
  const textWidth = calculateTextWidth(ingredient.name, ''.concat(fontSize, `px '`).concat(fontFamily, `'`));
  return /* #__PURE__ */ React__default.default.createElement(
    'g',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      key: ingredient.name,
    },
    AromaTypesArray.map((dot, idx) => {
      const _a = getDotProperty(dot, ingredient[dot]);
      const { size } = _a;
      const { color } = _a;

      const dotRadius = size / 2;
      return /* #__PURE__ */ React__default.default.createElement('circle', {
        xmlns: 'http://www.w3.org/2000/svg',
        key: dot,
        r: dotRadius,
        cx: initialOffsetX + cellWidth * idx,
        cy: offsetY,
        fill: color,
      });
    }),
    showIngredientTitle &&
      /* #__PURE__ */ React__default.default.createElement(
        'g',
        null,
        /* #__PURE__ */ React__default.default.createElement(
          'text',
          {
            fontSize,
            fontFamily,
            style: {
              fill: fontColor,
            },
            alignmentBaseline: 'middle',
            transform: 'matrix(1 0 0 1 '.concat(initialOffsetX - 40 - textWidth, ' ').concat(offsetY, ')'),
          },
          ingredient.name,
        ),
      ),
  );
};

DotGraphVizRow.defaultProps = {
  showIngredientTitle: false,
  fontColor: '#939598',
  fontSize: '18',
  fontFamily: 'Helvetica',
};
const DotGraphVizRow$1 = /* #__PURE__ */ React.memo(DotGraphVizRow);

const DotGraphVizTitleRow = function DotGraphVizTitleRow(_a) {
  const { cellWidth } = _a;
  const { color } = _a;
  const { fontSize } = _a;
  const { initialOffsetX } = _a;
  const { offsetY } = _a;
  return /* #__PURE__ */ React__default.default.createElement(
    'g',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      key: 'title-row',
    },
    /* #__PURE__ */ React__default.default.createElement(
      'g',
      {
        xmlns: 'http://www.w3.org/2000/svg',
      },
      AromaTypesArray.map((aromaType, idx) =>
        /* #__PURE__ */ React__default.default.createElement(
          'text',
          {
            key: ''.concat(aromaType, '_').concat(idx),
            fontSize,
            fontFamily: 'Helvetica',
            style: {
              fill: color || AromaColorMapping[aromaType],
            },
            transform: 'matrix(0.7071 -0.7071 0.7071 0.7071 '
              .concat(initialOffsetX + cellWidth * idx, ' ')
              .concat(offsetY, ')'),
            className: 'st0 st1 st15',
          },
          aromaType,
        ),
      ),
    ),
  );
};

DotGraphVizTitleRow.defaultProps = {
  color: '#939598',
  fontSize: '14',
};
const DotGraphVizTitleRow$1 = /* #__PURE__ */ React.memo(DotGraphVizTitleRow);

/**
 * namespace()
 */
function namespace() {
  const map = new WeakMap();
  return function (object) {
    if (!map.has(object)) {
      map.set(object, {});
    }

    return map.get(object);
  };
}

/**
 * AbstractProperty
 */

const _private$l = namespace();

const AbstractProperty = /* #__PURE__ */ (function () {
  function AbstractProperty(name, defaultValue) {
    _classCallCheck(this, AbstractProperty);

    console.assert(typeof name === 'string', 'Expected a string for a property name but instead got:', name);
    _private$l(this).name = name;
    _private$l(this).defaultValue = defaultValue;
  }

  _createClass(AbstractProperty, [
    {
      key: 'attachProperty',
      value: function attachProperty(object, storage) {
        throw new Error('attachProperty() called on AbstractProperty. Use a concrete subclass instead.');
      },
    },
    {
      key: 'updateValue',
      value: function updateValue(object, storage, newValue) {
        storage(object)[this.name] = newValue;
      },
    },
    {
      key: 'name',
      get: function get() {
        return _private$l(this).name;
      },
    },
    {
      key: 'defaultValue',
      get: function get() {
        return _private$l(this).defaultValue;
      },
    },
  ]);

  return AbstractProperty;
})();

/**
 * Tween
 */

const _private$k = namespace();

const Tween = /* #__PURE__ */ (function () {
  function Tween(start, target, time, lerp) {
    const ease = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Tween.easeLinear;

    _classCallCheck(this, Tween);

    performance.now();
    _private$k(this).startValue = start;
    _private$k(this).targetValue = target;
    _private$k(this).startTime = performance.now();
    _private$k(this).currentTime = _private$k(this).startTime;
    _private$k(this).endTime = _private$k(this).startTime + time;
    _private$k(this).lerp = lerp;
    _private$k(this).ease = ease;
  }

  _createClass(
    Tween,
    [
      {
        key: 'update',
        value: function update(deltaTime) {
          _private$k(this).currentTime += deltaTime;
        },
      },
      {
        key: 'currentTime',
        get: function get() {
          return _private$k(this).currentTime;
        },
      },
      {
        key: 'currentValue',
        get: function get() {
          return _private$k(this).lerp(this.startValue, this.targetValue, this.unitTime);
        },
      },
      {
        key: 'endTime',
        get: function get() {
          return _private$k(this).endTime;
        },
      },
      {
        key: 'elapsedTime',
        get: function get() {
          return Math.min(this.currentTime - this.startTime, this.totalTime);
        },
      },
      {
        key: 'isFinished',
        get: function get() {
          return this.currentTime >= this.endTime;
        },
      },
      {
        key: 'startTime',
        get: function get() {
          return _private$k(this).startTime;
        },
      },
      {
        key: 'startValue',
        get: function get() {
          return _private$k(this).startValue;
        },
      },
      {
        key: 'targetValue',
        get: function get() {
          return _private$k(this).targetValue;
        },
      },
      {
        key: 'totalTime',
        get: function get() {
          return this.endTime - this.startTime;
        },
      },
      {
        key: 'unitTime',
        get: function get() {
          return _private$k(this).ease(this.elapsedTime / this.totalTime);
        },
      },
    ],
    [
      {
        key: 'easeLinear',
        value: function easeLinear(t) {
          return t;
        },
      },
      {
        key: 'easeQuadratic',
        value: function easeQuadratic(t) {
          return t * t;
        },
      },
      {
        key: 'easeCubic',
        value: function easeCubic(t) {
          return t * t * t;
        },
      },
      {
        key: 'easeQuartic',
        value: function easeQuartic(t) {
          return t * t * t * t;
        },
      },
      {
        key: 'easeQuintic',
        value: function easeQuintic(t) {
          return t * t * t * t * t;
        },
      },
      {
        key: 'lerpColor',
        value: function lerpColor(c0, c1, t) {
          return {
            red: Animation.lerpNumber(c0.red, c1.red, t),
            green: Animation.lerpNumber(c0.green, c1.green, t),
            blue: Animation.lerpNumber(c0.blue, c1.blue, t),
          };
        },
      },
      {
        key: 'lerpNumber',
        value: function lerpNumber(n0, n1, t) {
          return t * n1 + (1 - t) * n0;
        },
      },
      {
        key: 'lerpPoint',
        value: function lerpPoint(p0, p1, t) {
          return {
            x: Tween.lerpNumber(p0.x, p1.x, t),
            y: Tween.lerpNumber(p0.y, p1.y, t),
          };
        },
      },
    ],
  );

  return Tween;
})();

/**
 * AnimatedProperty
 */

const _private$j = namespace();

const AnimatedProperty = /* #__PURE__ */ (function (_AbstractProperty) {
  _inherits(AnimatedProperty, _AbstractProperty);

  const _super = _createSuper(AnimatedProperty);

  function AnimatedProperty(name, defaultValue, lerpFunction) {
    let _this;

    const easeFunction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Tween.easeLinear;

    _classCallCheck(this, AnimatedProperty);

    console.assert(
      typeof lerpFunction === 'function',
      'Expected a function for an lerpFunction but instead got:',
      lerpFunction,
    );
    console.assert(
      typeof easeFunction === 'function',
      'Expected a function for an easeFunction but instead got:',
      easeFunction,
    );
    _this = _super.call(this, name, defaultValue);
    _private$j(_assertThisInitialized(_this)).lerpFunction = lerpFunction;
    _private$j(_assertThisInitialized(_this)).easeFunction = easeFunction;
    return _this;
  }

  _createClass(AnimatedProperty, [
    {
      key: 'attachBlock',
      value: function attachBlock(object, storage) {
        const _prototype = Object.getPrototypeOf(object);

        const _class = Object.getPrototypeOf(_prototype);

        const blockName = this.name;
        const properName = blockName.charAt(0).toUpperCase() + blockName.slice(1);

        if (!_class.hasOwnProperty(blockName)) {
          const animateName = 'animate'.concat(properName);
          const animateLerp = this.lerpFunction;
          const animateEase = this.easeFunction;

          const animateFunc = function animateFunc(target, time) {
            const start = storage(this)[blockName];
            storage(this)[animateName] = new Animation(start, target, time, animateLerp, animateEase);
          };

          Object.defineProperty(_class, animateName, {
            value: animateFunc,
          });

          const getFunc = function getFunc() {
            return storage(this)[blockName];
          };

          const setFunc = function setFunc(newValue) {
            storage(this)[blockName] = newValue;
            storage(this)[animateName] = null;
          };

          Object.defineProperty(_class, blockName, {
            get: getFunc,
            set: setFunc,
          });
          const getName = 'get'.concat(properName);
          Object.defineProperty(_class, getName, {
            value: getFunc,
          });
          const setName = 'set'.concat(properName);
          Object.defineProperty(_class, setName, {
            value: setFunc,
          });

          const updateFunc = function updateFunc(deltaTime) {
            if (storage(this)[animateName]) {
              storage(this)[animateName].update(deltaTime);
              storage(this)[blockName] = storage(this)[animateName].currentValue;

              if (storage(this)[animateName].isFinished) {
                storage(this)[animateName] = null;
              }
            }
          };

          const updateName = 'update'.concat(properName);
          Object.defineProperty(_class, updateName, {
            value: updateFunc,
          });
        }
      },
    },
    {
      key: 'easeFunction',
      get: function get() {
        return _private$j(this).easeFunction;
      },
    },
    {
      key: 'lerpFunction',
      get: function get() {
        return _private$j(this).lerpFunction;
      },
    },
  ]);

  return AnimatedProperty;
})(AbstractProperty);

/**
 * Arguments
 */

const _private$i = namespace();

const Arguments = /* #__PURE__ */ (function () {
  function Arguments() {
    _classCallCheck(this, Arguments);

    _private$i(this).args = {};

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    for (let i = 0; i < args.length; i++) {
      if (args[i] === Object(args[i])) {
        for (let _i = 0, _Object$keys = Object.keys(args[i]); _i < _Object$keys.length; _i++) {
          const name = _Object$keys[_i];
          _private$i(this).args[name] = args[i][name];
        }
      }
    }
  }

  _createClass(Arguments, [
    {
      key: 'get',
      value: function get(name) {
        return _private$i(this).args[name];
      },
    },
    {
      key: 'has',
      value: function has(name) {
        return !(typeof _private$i(this).args[name] === 'undefined');
      },
    },
  ]);

  return Arguments;
})();

/**
 * ObservedProperty
 */

const _private$h = namespace();

const ObservedProperty = /* #__PURE__ */ (function (_AbstractProperty) {
  _inherits(ObservedProperty, _AbstractProperty);

  const _super = _createSuper(ObservedProperty);

  function ObservedProperty(name, defaultValue) {
    let _this;

    const observerName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'didSet';

    _classCallCheck(this, ObservedProperty);

    console.assert(
      typeof observerName === 'string',
      'Expected a string for an observerName but instead got:',
      observerName,
    );
    _this = _super.call(this, name, defaultValue);
    _private$h(_assertThisInitialized(_this)).observerName = observerName;
    return _this;
  }

  _createClass(ObservedProperty, [
    {
      key: 'attachProperty',
      value: function attachProperty(object, storage) {
        const _prototype = Object.getPrototypeOf(object);

        const _class = Object.getPrototypeOf(_prototype);

        const blockName = this.name;
        const properName = blockName.charAt(0).toUpperCase() + blockName.slice(1);
        const observerName = this.observerName + properName;

        if (!_class.hasOwnProperty(blockName)) {
          const getFunc = function getFunc() {
            return storage(this)[blockName];
          };

          const setFunc = function setFunc(newValue) {
            storage(this)[blockName] = newValue;
            this[observerName](newValue);
          };

          Object.defineProperty(_class, blockName, {
            get: getFunc,
            set: setFunc,
          });
          const getName = 'get'.concat(properName);
          Object.defineProperty(_class, getName, {
            value: getFunc,
          });
          const setName = 'set'.concat(properName);
          Object.defineProperty(_class, setName, {
            value: setFunc,
          });
        }
      },
    },
    {
      key: 'observerName',
      get: function get() {
        return _private$h(this).observerName;
      },
    },
  ]);

  return ObservedProperty;
})(AbstractProperty);

/**
 * Property
 */

const Property = /* #__PURE__ */ (function (_AbstractProperty) {
  _inherits(Property, _AbstractProperty);

  const _super = _createSuper(Property);

  function Property(name, defaultValue) {
    _classCallCheck(this, Property);

    return _super.call(this, name, defaultValue);
  }

  _createClass(Property, [
    {
      key: 'attachProperty',
      value: function attachProperty(object, storage) {
        const _prototype = Object.getPrototypeOf(object);

        const _class = Object.getPrototypeOf(_prototype);

        const blockName = this.name;
        const properName = blockName.charAt(0).toUpperCase() + blockName.slice(1);

        if (!_class.hasOwnProperty(blockName)) {
          const getFunc = function getFunc() {
            return storage(this)[blockName];
          };

          const setFunc = function setFunc(newValue) {
            storage(this)[blockName] = newValue;
          };

          Object.defineProperty(_class, blockName, {
            get: getFunc,
            set: setFunc,
          });
          const getName = 'get'.concat(properName);
          Object.defineProperty(_class, getName, {
            value: getFunc,
          });
          const setName = 'set'.concat(properName);
          Object.defineProperty(_class, setName, {
            value: setFunc,
          });
        }
      },
    },
  ]);

  return Property;
})(AbstractProperty);

/**
 * defineProperties
 *
 * @param Base
 * @param ...properties
 * @returns {undefined}
 */

const _storage = namespace();

const defineProperties = function defineProperties(Base) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  return /* #__PURE__ */ (function (_Base) {
    _inherits(_class, _Base);

    const _super = _createSuper(_class);

    function _class() {
      let _this;

      _classCallCheck(this, _class);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      const _args = _construct(Arguments, args);

      const _iterator = _createForOfIteratorHelper(properties);
      let _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          const p = _step.value;
          console.assert(
            p instanceof AbstractProperty,
            'Expected a concrete subclass of AbstractProperty and instead got:',
            p,
          );
          p.attachProperty(_assertThisInitialized(_this), _storage);
          p.updateValue(
            _assertThisInitialized(_this),
            _storage,
            _args.has(p.name) ? _args.get(p.name) : p.defaultValue,
          );
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return _this;
    }

    return _createClass(_class);
  })(Base);
};
/**
 * object
 */

const object = {
  AnimatedProperty,
  Arguments,
  defineProperties,
  ObservedProperty,
  Property,
  Tween,
};

/**
 * Category
 */

const _private$g = namespace();

const Category = /* #__PURE__ */ (function () {
  function Category(object) {
    _classCallCheck(this, Category);

    console.assert(_typeof(object) === 'object', 'Expected <object> for object but instead got:', object);
    console.assert(typeof object.id === 'number', 'Expected <int> for object.id but instead got:', object.id);
    _private$g(this).id = parseInt(object.id);
    console.assert(
      _typeof(object._meta) === 'object',
      'Expected <object> for object._meta but instead got:',
      object._meta,
    );
    console.assert(
      typeof object._meta.index === 'number',
      'Expected <int> for object._meta.index but instead got:',
      object._meta.index,
    );
    _private$g(this).index = parseInt(object._meta.index);
    console.assert(
      typeof object._meta.color === 'string',
      'Expected <hex> for object._meta.color but instead got:',
      object._meta.color,
    );
    _private$g(this).color = object._meta.color;
    console.assert(typeof object.name === 'string', 'Expected <str> for object.name but instead got:', object.name);
    _private$g(this).name = object.name; // console.assert(typeof(object.description) === 'string',
    //    'Expected <str> for object.description but instead got:', object.description);

    _private$g(this).description = object.description;
  }

  _createClass(Category, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this.id,
          _meta: {
            color: this.color,
            index: this.index,
          },
          name: this.name,
          description: this.description,
        };
      },
    },
    {
      key: 'color',
      get: function get() {
        return _private$g(this).color;
      },
      set: function set(v) {
        _private$g(this).color = v;
      },
    },
    {
      key: 'description',
      get: function get() {
        return _private$g(this).description;
      },
    },
    {
      key: 'id',
      get: function get() {
        return _private$g(this).id;
      },
    },
    {
      key: 'index',
      get: function get() {
        return _private$g(this).index;
      },
    },
    {
      key: 'name',
      get: function get() {
        return _private$g(this).name;
      },
    },
  ]);

  return Category;
})();

/**
 * Descriptor
 */

const _private$f = namespace();

const Descriptor = /* #__PURE__ */ (function () {
  function Descriptor(object) {
    _classCallCheck(this, Descriptor);

    console.assert(_typeof(object) === 'object', 'Expected <object> for object but instead got:', object);
    console.assert(typeof object.id === 'number', 'Expected <int> for object.id but instead got:', object.id);
    _private$f(this).id = parseInt(object.id);
    console.assert(
      _typeof(object._meta) === 'object',
      'Expected <object> for object._meta but instead got:',
      object._meta,
    );
    console.assert(
      typeof object._meta.index === 'number',
      'Expected <int> for object._meta.index but instead got:',
      object._meta.index,
    );
    _private$f(this).index = parseInt(object._meta.index);
    console.assert(
      typeof object._meta.color === 'string',
      'Expected <hex> for object._meta.color but instead got:',
      object._meta.color,
    );
    _private$f(this).color = object._meta.color;
    console.assert(typeof object.name === 'string', 'Expected <str> for object.name but instead got:', object.name);
    _private$f(this).name = object.name; // console.assert(typeof(object.description) === 'string',
    //    'Expected <str> for object.description but instead got:', object.description);
    // _private(this).description = object.description;

    console.assert(
      _typeof(object._links) === 'object',
      'Expected <object> for object._links but instead got:',
      object._links,
    );
    console.assert(
      _typeof(object._links.type) === 'object',
      'Expected <object> for object._links.type instead got:',
      object._links.type,
    );
    _private$f(this).category = new Category(object._links.type);
  }

  _createClass(Descriptor, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this.id,
          _meta: {
            color: this.color,
            index: this.index,
          },
          name: this.name,
          description: this.description,
          _links: {
            type: this.category.toJSON(),
          },
        };
      },
    },
    {
      key: 'category',
      get: function get() {
        return _private$f(this).category;
      },
    },
    {
      key: 'color',
      get: function get() {
        return _private$f(this).color;
      },
      set: function set(v) {
        _private$f(this).color = v;
      },
    },
    {
      key: 'description',
      get: function get() {
        return _private$f(this).description;
      },
    },
    {
      key: 'id',
      get: function get() {
        return _private$f(this).id;
      },
    },
    {
      key: 'index',
      get: function get() {
        return _private$f(this).index;
      },
    },
    {
      key: 'name',
      get: function get() {
        return _private$f(this).name;
      },
    },
  ]);

  return Descriptor;
})();

/**
 * Aroma
 */

const _private$e = namespace();

const Aroma = /* #__PURE__ */ (function () {
  function Aroma(object) {
    _classCallCheck(this, Aroma);

    console.assert(_typeof(object) === 'object', 'Expected <object> for object but instead got:', object);
    console.assert(
      _typeof(object.value) === 'object',
      'Expected <object> for object.value but instead got:',
      object.value,
    );
    console.assert(
      typeof object.value.rel === 'number',
      'Expected <float> for object.value.rel but instead got:',
      object.value.rel,
    );
    _private$e(this).value = parseFloat(object.value.rel); // console.assert(typeof(object._meta) === 'object',
    // 'Expected <object> for object._meta but instead got:', object._meta);
    // console.assert(typeof(object._meta.index) === 'number' || typeof(object._meta.index) === 'undefined',
    // 'Expected <int> for object._meta.index but instead got:', object._meta.index);
    // _private(this).index = (object._meta.index) ? parseInt(object._meta.index) : undefined;

    console.assert(
      _typeof(object._links) === 'object',
      'Expected <object> for object._links but instead got:',
      object._links,
    );
    console.assert(
      _typeof(object._links.descriptor) === 'object',
      'Expected <object> for object._links.descriptor instead got:',
      object._links.descriptor,
    );
    _private$e(this).descriptor = new Descriptor(object._links.descriptor);
  }

  _createClass(Aroma, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          value: {
            rel: this.value,
          },
          // _meta: {
          // index: this.index
          // },
          _links: {
            descriptor: this.descriptor.toJSON(),
          },
        };
      },
    },
    {
      key: 'descriptor',
      get: function get() {
        return _private$e(this).descriptor;
      }, // get index() {
      // return _private(this).index;
      // }
    },
    {
      key: 'value',
      get: function get() {
        const v = Number(parseFloat(_private$e(this).value).toFixed(12)); // v = v > 0.01 ? v : 0;

        return v;
      },
    },
  ]);

  return Aroma;
})();

/**
 * Ingredient
 */

const _private$d = namespace();

const Ingredient = /* #__PURE__ */ (function () {
  function Ingredient(object) {
    _classCallCheck(this, Ingredient);

    console.assert(_typeof(object) === 'object', 'Expected <object> for object but instead got:', object);
    console.assert(
      _typeof(object.ingredient) === 'object',
      'Expected <object> for object.ingredient but instead got:',
      object.ingredient,
    );
    console.assert(
      typeof object.ingredient.id === 'number',
      'Expected <int> for object.ingredient.id but instead got:',
      object.ingredient.id,
    );
    _private$d(this).id = parseInt(object.ingredient.id);
    console.assert(
      typeof object.ingredient.href === 'string',
      'Expected <str> for object.ingredient.href but instead got:',
      object.ingredient.href,
    );
    _private$d(this).href = object.ingredient.href;
    console.assert(
      typeof object.intensity === 'number',
      'Expected <float> for object.intensity but instead got:',
      object.intensity,
    );
    _private$d(this).intensity = parseFloat(object.intensity);
    _private$d(this).name = String(object.name);
    console.assert(Array.isArray(object.aromas), 'Expected <array> for object.aromas but instead got:', object.aromas);
    object.aromas.sort((a, b) => {
      const ca = a._links.descriptor._links.type._meta.index;
      const cb = b._links.descriptor._links.type._meta.index;

      if (ca === cb) {
        const da = a._links.descriptor._meta.index;
        const db = b._links.descriptor._meta.index;
        return da - db;
      }

      return ca - cb;
    });
    const placeholder = null;
    _private$d(this).aromas = [];
    _private$d(this).aromaLookup = {};
    _private$d(this).categories = [placeholder];
    _private$d(this).categoryLookup = {};

    const _iterator = _createForOfIteratorHelper(object.aromas);
    let _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        const obj = _step.value;

        const _aroma = new Aroma(obj);

        const { descriptor } = _aroma;
        const _category = descriptor.category;

        const _aindex = _private$d(this).aromas.length;

        _private$d(this).aromas.push(_aroma);

        _private$d(this).aromaLookup[descriptor.name] = _aindex;

        const cindex = _private$d(this).categoryLookup[_category.name];

        if (cindex) {
          _private$d(this).categories[cindex].push(_aindex);
        } else {
          const nindex = _private$d(this).categories.length;

          _private$d(this).categories.push([_aindex]);

          _private$d(this).categoryLookup[_category.name] = nindex;
        }
      } /// Remove placeholder and shift indices down
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _private$d(this).categories.shift();

    for (let _i = 0, _Object$keys = Object.keys(_private$d(this).categoryLookup); _i < _Object$keys.length; _i++) {
      const name = _Object$keys[_i];
      _private$d(this).categoryLookup[name] -= 1;
    } /// Compute statistics

    const statistics = {};
    statistics.categories = {};
    statistics.maxValue = Number.MIN_VALUE;
    statistics.minValue = Number.MAX_VALUE;
    statistics.maxCategoryValue = Number.MIN_VALUE;
    statistics.minCategoryValue = Number.MAX_VALUE;
    statistics.totalValue = 0;

    for (let aindex = 0; aindex < this.aromaCount; aindex++) {
      const aroma = this.getAromaByIndex(aindex);
      statistics.maxValue = Math.max(statistics.maxValue, aroma.value);
      statistics.minValue = Math.min(statistics.minValue, aroma.value);
      statistics.totalValue += aroma.value;
      const { category } = aroma.descriptor;
      const _name = category.name;

      if (statistics.categories[_name]) {
        statistics.categories[_name].maxValue = Math.max(statistics.categories[_name].maxValue, aroma.value);
        statistics.categories[_name].minValue = Math.min(statistics.categories[_name].minValue, aroma.value);
        statistics.categories[_name].totalValue += aroma.value;
      } else {
        statistics.categories[_name] = {
          maxValue: aroma.value,
          minValue: aroma.value,
          totalValue: aroma.value,
        };
      }

      statistics.maxCategoryValue = Math.max(statistics.maxCategoryValue, statistics.categories[_name].totalValue);
      statistics.minCategoryValue = Math.min(statistics.minCategoryValue, statistics.categories[_name].totalValue);
    }

    _private$d(this).statistics = statistics;
  }

  _createClass(Ingredient, [
    {
      key: 'getCategoryByIndex',
      value: function getCategoryByIndex(index) {
        const aromaIndices = _private$d(this).categories[index];

        return aromaIndices ? this.getAromaByIndex(aromaIndices[0]).descriptor.category : undefined;
      },
    },
    {
      key: 'getCategoryByName',
      value: function getCategoryByName(name) {
        return this.getCategoryByIndex(_private$d(this).categoryLookup[name]);
      },
    },
    {
      key: 'getAromaByIndex',
      value: function getAromaByIndex(index) {
        return _private$d(this).aromas[index];
      },
    },
    {
      key: 'getAromaByDescriptorName',
      value: function getAromaByDescriptorName(name) {
        return this.getAromaByIndex(_private$d(this).aromaLookup[name]);
      },
    },
    {
      key: 'getAromasForCategory',
      value: function getAromasForCategory(category) {
        const index = _private$d(this).categoryLookup[category.name];

        const _private2 = _private$d(this);
        const { aromas } = _private2;

        const aromaIndices = _private$d(this).categories[index];

        return aromaIndices ? aromaIndices.map((idx) => aromas[idx]) : undefined;
      },
    },
    {
      key: 'getMaxAromaValueForCategory',
      value: function getMaxAromaValueForCategory(category) {
        return _private$d(this).statistics.categories[category.name].maxValue;
      },
    },
    {
      key: 'getMinAromaValueForCategory',
      value: function getMinAromaValueForCategory(category) {
        return _private$d(this).statistics.categories[category.name].minValue;
      },
    },
    {
      key: 'getTotalAromaValueForCategory',
      value: function getTotalAromaValueForCategory(category) {
        return _private$d(this).statistics.categories[category.name].totalValue;
      },
    },
    {
      key: 'toJSON',
      value: function toJSON() {
        const aromas = [];

        for (let index = 0; index < this.aromaCount; index++) {
          const aroma = this.getAromaByIndex(index);
          aromas.push(aroma.toJSON());
        }

        return {
          ingredient: {
            id: this.id,
            href: this.href,
          },
          intensity: this.intensity,
          aromas,
        };
      },
    },
    {
      key: 'aromaCount',
      get: function get() {
        return _private$d(this).aromas.length;
      },
    },
    {
      key: 'categoryCount',
      get: function get() {
        return _private$d(this).categories.length;
      },
    },
    {
      key: 'descriptorCount',
      get: function get() {
        return this.aromaCount;
      },
    },
    {
      key: 'href',
      get: function get() {
        return _private$d(this).href;
      },
    },
    {
      key: 'id',
      get: function get() {
        return _private$d(this).id;
      },
    },
    {
      key: 'intensity',
      get: function get() {
        return _private$d(this).intensity;
      },
    },
    {
      key: 'maxAromaValue',
      get: function get() {
        return _private$d(this).statistics.maxValue;
      },
    },
    {
      key: 'minAromaValue',
      get: function get() {
        return _private$d(this).statistics.minValue;
      },
    },
    {
      key: 'maxCategoryValue',
      get: function get() {
        return _private$d(this).statistics.maxCategoryValue;
      },
    },
    {
      key: 'minCategoryValue',
      get: function get() {
        return _private$d(this).statistics.minCategoryValue;
      },
    },
    {
      key: 'totalAromaValue',
      get: function get() {
        return _private$d(this).statistics.totalValue;
      },
    },
    {
      key: 'name',
      get: function get() {
        return _private$d(this).name;
      },
    },
  ]);

  return Ingredient;
})();

/**
 * IngredientHandle
 */

const _private$c = namespace();

const IngredientHandle = /* #__PURE__ */ (function () {
  function IngredientHandle(object) {
    _classCallCheck(this, IngredientHandle);

    console.assert(_typeof(object) === 'object', 'Expected <object> for object but instead got:', object);
    console.assert(typeof object.id === 'number', 'Expected <int> for object.id but instead got:', object.id);
    _private$c(this).id = parseInt(object.id);
    console.assert(typeof object.name === 'string', 'Expected <str> for object.name but instead got:', object.name);
    _private$c(this).name = object.name;
  }

  _createClass(IngredientHandle, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this.id,
          name: this.name,
        };
      },
    },
    {
      key: 'toString',
      value: function toString() {
        return this.isCustom ? this.name : ''.concat(this.name, ' [').concat(String(this.id), ']');
      },
    },
    {
      key: 'id',
      get: function get() {
        return _private$c(this).id;
      },
    },
    {
      key: 'isCustom',
      get: function get() {
        return this.id < 0;
      },
    },
    {
      key: 'name',
      get: function get() {
        return _private$c(this).name;
      },
    },
  ]);

  return IngredientHandle;
})();

/**
 * Taxonomy
 */

const _private$b = namespace();

const Taxonomy = /* #__PURE__ */ (function () {
  function Taxonomy(array) {
    _classCallCheck(this, Taxonomy);

    console.assert(Array.isArray(array), 'Expected <array> for object but instead got:', array);
    const placeholder = null;
    _private$b(this).descriptors = [];
    _private$b(this).descriptorLookup = {};
    _private$b(this).categories = [placeholder];
    _private$b(this).categoryLookup = {};
    array.sort((a, b) => {
      const ca = a._links.type._meta.index;
      const cb = b._links.type._meta.index;

      if (ca === cb) {
        const da = a._meta.index;
        const db = b._meta.index;
        return da - db;
      }

      return ca - cb;
    });

    const _iterator = _createForOfIteratorHelper(array);
    let _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        const object = _step.value;
        const descriptor = new Descriptor(object);

        const dindex = _private$b(this).descriptors.length;

        _private$b(this).descriptors.push(descriptor);

        _private$b(this).descriptorLookup[descriptor.name] = dindex;
        const { category } = descriptor;

        const cindex = _private$b(this).categoryLookup[category.name];

        if (cindex) {
          _private$b(this).categories[cindex].push(dindex);
        } else {
          const nindex = _private$b(this).categories.length;

          _private$b(this).categories.push([dindex]);

          _private$b(this).categoryLookup[category.name] = nindex;
        }
      } /// Remove placeholder and shift indices down
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _private$b(this).categories.shift();

    for (let _i = 0, _Object$keys = Object.keys(_private$b(this).categoryLookup); _i < _Object$keys.length; _i++) {
      const name = _Object$keys[_i];
      _private$b(this).categoryLookup[name] -= 1;
    }
  }

  _createClass(Taxonomy, [
    {
      key: 'getCategoryByIndex',
      value: function getCategoryByIndex(index) {
        const descriptorIndices = _private$b(this).categories[index];

        return descriptorIndices ? this.getDescriptorByIndex(descriptorIndices[0]).category : undefined;
      },
    },
    {
      key: 'getCategoryByName',
      value: function getCategoryByName(name) {
        return this.getCategoryByIndex(_private$b(this).categoryLookup[name]);
      },
    },
    {
      key: 'getDescriptorByIndex',
      value: function getDescriptorByIndex(index) {
        return _private$b(this).descriptors[index];
      },
    },
    {
      key: 'getDescriptorByName',
      value: function getDescriptorByName(name) {
        return this.getDescriptorByIndex(_private$b(this).descriptorLookup[name]);
      },
    },
    {
      key: 'getDescriptorsForCategory',
      value: function getDescriptorsForCategory(category) {
        const index = _private$b(this).categoryLookup[category.name];

        const _private2 = _private$b(this);
        const { descriptors } = _private2;

        const descriptorIndices = _private$b(this).categories[index];

        return descriptorIndices.map((idx) => descriptors[idx]);
      },
    },
    {
      key: 'toJSON',
      value: function toJSON() {
        const output = [];

        for (let index = 0; index < this.descriptorCount; index++) {
          const descriptor = this.getDescriptorByIndex(index);
          output.push(descriptor.toJSON());
        }

        return output;
      },
    },
    {
      key: 'categoryCount',
      get: function get() {
        return _private$b(this).categories.length;
      },
    },
    {
      key: 'descriptorCount',
      get: function get() {
        return _private$b(this).descriptors.length;
      },
    },
    {
      key: 'setCategoryColor',
      value: function setCategoryColor(name, value) {
        const cat = this.getCategoryByName(name);
        cat.color = value;
        const desc = this.getDescriptorsForCategory(cat);

        const _iterator2 = _createForOfIteratorHelper(desc);
        let _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
            const d = _step2.value;
            d.color = value;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      },
    },
  ]);

  return Taxonomy;
})();

const TaxonomyClassification = /* #__PURE__ */ (function (_Ingredient) {
  _inherits(TaxonomyClassification, _Ingredient);

  const _super = _createSuper(TaxonomyClassification);

  function TaxonomyClassification(object) {
    _classCallCheck(this, TaxonomyClassification);

    object = TaxonomyClassification.transformTaxonomyToIngredient(object);
    console.log(object);
    return _super.call(this, object);
  }

  _createClass(TaxonomyClassification, null, [
    {
      key: 'transformTaxonomyToIngredient',
      value: function transformTaxonomyToIngredient(object) {
        const ing = {
          ingredient: {
            id: 0,
            href: '',
          },
          intensity: 1,
        };
        ing.aromas = [];

        for (let i = 0, len = object.length; i < len; i++) {
          ing.aromas.push({
            value: {
              rel: 0.5,
            },
            _links: {
              descriptor: object[i],
            },
            _meta: {
              index: i,
            },
          });
        }

        return ing;
      },
    },
  ]);

  return TaxonomyClassification;
})(Ingredient);

/**
 * Dependencies
 */
/**
 * models
 */

const models = {
  Aroma,
  Category,
  Descriptor,
  Ingredient,
  IngredientHandle,
  Taxonomy,
  TaxonomyClassification,
};

const ingredient = {
  id: 6045,
  href: 'https://api.foodpairing.com/ingredients/6045',
};
const intensity = 1;
const name = 'Adelscott';
const aromas = [
  {
    value: { rel: 0.1098948272161408 },
    _links: {
      descriptor: {
        id: 3266,
        name: 'Apple',
        description: '',
        _meta: { index: 0, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 0 },
  },
  {
    value: { rel: 0.0034342133505044 },
    _links: {
      descriptor: {
        id: 3268,
        name: 'Banana',
        description: '',
        _meta: { index: 1, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 1 },
  },
  {
    value: { rel: 0.0017171066752522 },
    _links: {
      descriptor: {
        id: 3271,
        name: 'Coconut',
        description: '',
        _meta: { index: 3, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 2 },
  },
  {
    value: { rel: 0.030907920154539602 },
    _links: {
      descriptor: {
        id: 3265,
        name: 'Fruity',
        description: '',
        _meta: { index: 4, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 3 },
  },
  {
    value: { rel: 0.014166130070830651 },
    _links: {
      descriptor: {
        id: 3267,
        name: 'Pineapple',
        description: '',
        _meta: { index: 7, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 4 },
  },
  {
    value: { rel: 0.0034342133505044 },
    _links: {
      descriptor: {
        id: 3269,
        name: 'Tropical',
        description: '',
        _meta: { index: 8, color: '#fdb515' },
        _links: {
          type: {
            id: 3251,
            name: 'Fruity',
            description: '',
            _meta: { index: 0, color: '#fdb515' },
          },
        },
      },
    },
    _meta: { index: 5 },
  },
  {
    value: { rel: 0.12363168061815841 },
    _links: {
      descriptor: {
        id: 3298,
        name: 'Floral',
        description: '',
        _meta: { index: 0, color: '#9c2d88' },
        _links: {
          type: {
            id: 3256,
            name: 'Floral',
            description: '',
            _meta: { index: 1, color: '#9c2d88' },
          },
        },
      },
    },
    _meta: { index: 6 },
  },
  {
    value: { rel: 0.000214638334406525 },
    _links: {
      descriptor: {
        id: 3301,
        name: 'Geranium',
        description: '',
        _meta: { index: 1, color: '#9c2d88' },
        _links: {
          type: {
            id: 3256,
            name: 'Floral',
            description: '',
            _meta: { index: 1, color: '#9c2d88' },
          },
        },
      },
    },
    _meta: { index: 7 },
  },
  {
    value: { rel: 0.12384631895256493 },
    _links: {
      descriptor: {
        id: 3300,
        name: 'Honey',
        description: '',
        _meta: { index: 2, color: '#9c2d88' },
        _links: {
          type: {
            id: 3256,
            name: 'Floral',
            description: '',
            _meta: { index: 1, color: '#9c2d88' },
          },
        },
      },
    },
    _meta: { index: 8 },
  },
  {
    value: { rel: 0.0412105602060528 },
    _links: {
      descriptor: {
        id: 3299,
        name: 'Rose',
        description: '',
        _meta: { index: 3, color: '#9c2d88' },
        _links: {
          type: {
            id: 3256,
            name: 'Floral',
            description: '',
            _meta: { index: 1, color: '#9c2d88' },
          },
        },
      },
    },
    _meta: { index: 9 },
  },
  {
    value: { rel: 0.0034342133505044 },
    _links: {
      descriptor: {
        id: 3324,
        name: 'Orange',
        description: '',
        _meta: { index: 3, color: '#f8ec1c' },
        _links: {
          type: {
            id: 3262,
            name: 'Citrus',
            description: '',
            _meta: { index: 2, color: '#f8ec1c' },
          },
        },
      },
    },
    _meta: { index: 10 },
  },
  {
    value: { rel: 0.028332260141661302 },
    _links: {
      descriptor: {
        id: 3309,
        name: 'Caramel',
        description: '',
        _meta: { index: 0, color: '#d3892a' },
        _links: {
          type: {
            id: 3258,
            name: 'Caramel',
            description: '',
            _meta: { index: 6, color: '#d3892a' },
          },
        },
      },
    },
    _meta: { index: 11 },
  },
  {
    value: { rel: 0.0034342133505044 },
    _links: {
      descriptor: {
        id: 3310,
        name: 'Maple',
        description: '',
        _meta: { index: 1, color: '#d3892a' },
        _links: {
          type: {
            id: 3258,
            name: 'Caramel',
            description: '',
            _meta: { index: 6, color: '#d3892a' },
          },
        },
      },
    },
    _meta: { index: 12 },
  },
  {
    value: { rel: 0.0010731916720326251 },
    _links: {
      descriptor: {
        id: 3303,
        name: 'Popcorn',
        description: '',
        _meta: { index: 4, color: '#6a431e' },
        _links: {
          type: {
            id: 3257,
            name: 'Roasted',
            description: '',
            _meta: { index: 7, color: '#6a431e' },
          },
        },
      },
    },
    _meta: { index: 13 },
  },
  {
    value: { rel: 0.0008585533376261 },
    _links: {
      descriptor: {
        id: 3306,
        name: 'Roasted',
        description: '',
        _meta: { index: 5, color: '#6a431e' },
        _links: {
          type: {
            id: 3257,
            name: 'Roasted',
            description: '',
            _meta: { index: 7, color: '#6a431e' },
          },
        },
      },
    },
    _meta: { index: 14 },
  },
  {
    value: { rel: 0.0145954067396437 },
    _links: {
      descriptor: {
        id: 3311,
        name: 'Nutty',
        description: '',
        _meta: { index: 1, color: '#d3a72a' },
        _links: {
          type: {
            id: 3259,
            name: 'Nutty',
            description: '',
            _meta: { index: 8, color: '#d3a72a' },
          },
        },
      },
    },
    _meta: { index: 15 },
  },
  {
    value: { rel: 0.2197896544322816 },
    _links: {
      descriptor: {
        id: 3275,
        name: 'Clove',
        description: '',
        _meta: { index: 3, color: '#ef4624' },
        _links: {
          type: {
            id: 3252,
            name: 'Spicy',
            description: '',
            _meta: { index: 9, color: '#ef4624' },
          },
        },
      },
    },
    _meta: { index: 16 },
  },
  {
    value: { rel: 0.0008585533376261 },
    _links: {
      descriptor: {
        id: 3278,
        name: 'Spicy',
        description: '',
        _meta: { index: 6, color: '#ef4624' },
        _links: {
          type: {
            id: 3252,
            name: 'Spicy',
            description: '',
            _meta: { index: 9, color: '#ef4624' },
          },
        },
      },
    },
    _meta: { index: 17 },
  },
  {
    value: { rel: 0.1098948272161408 },
    _links: {
      descriptor: {
        id: 3274,
        name: 'Vanilla',
        description: '',
        _meta: { index: 7, color: '#ef4624' },
        _links: {
          type: {
            id: 3252,
            name: 'Spicy',
            description: '',
            _meta: { index: 9, color: '#ef4624' },
          },
        },
      },
    },
    _meta: { index: 18 },
  },
  {
    value: { rel: 0.0137368534020176 },
    _links: {
      descriptor: {
        id: 3320,
        name: 'Balsamic',
        description: '',
        _meta: { index: 0, color: '#ba7031' },
        _links: {
          type: {
            id: 3261,
            name: 'Woody',
            description: '',
            _meta: { index: 10, color: '#ba7031' },
          },
        },
      },
    },
    _meta: { index: 19 },
  },
  {
    value: { rel: 0.00042927666881305 },
    _links: {
      descriptor: {
        id: 3321,
        name: 'Phenolic',
        description: '',
        _meta: { index: 1, color: '#ba7031' },
        _links: {
          type: {
            id: 3261,
            name: 'Woody',
            description: '',
            _meta: { index: 10, color: '#ba7031' },
          },
        },
      },
    },
    _meta: { index: 20 },
  },
  {
    value: { rel: 0.0274737068040352 },
    _links: {
      descriptor: {
        id: 3318,
        name: 'Smoky',
        description: '',
        _meta: { index: 3, color: '#ba7031' },
        _links: {
          type: {
            id: 3261,
            name: 'Woody',
            description: '',
            _meta: { index: 10, color: '#ba7031' },
          },
        },
      },
    },
    _meta: { index: 21 },
  },
  {
    value: { rel: 0.1098948272161408 },
    _links: {
      descriptor: {
        id: 3319,
        name: 'Woody',
        description: '',
        _meta: { index: 4, color: '#ba7031' },
        _links: {
          type: {
            id: 3261,
            name: 'Woody',
            description: '',
            _meta: { index: 10, color: '#ba7031' },
          },
        },
      },
    },
    _meta: { index: 22 },
  },
  {
    value: { rel: 0.0137368534020176 },
    _links: {
      descriptor: {
        id: 3330,
        name: 'Dusty',
        description: '',
        _meta: { index: 1, color: '#aaa9aa' },
        _links: {
          type: {
            id: 3264,
            name: 'Chemical',
            description: '',
            _meta: { index: 13, color: '#aaa9aa' },
          },
        },
      },
    },
    _meta: { index: 23 },
  },
];
const ingredientJSON = {
  ingredient,
  intensity,
  name,
  aromas,
};

const taxonomyJSON = [
  {
    id: 3265,
    _meta: { color: '#FFB600', index: 4 },
    name: 'Fruity',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3266,
    _meta: { color: '#FFB600' },
    name: 'Apple',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3267,
    _meta: { color: '#FFB600', index: 7 },
    name: 'Pineapple',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3268,
    _meta: { color: '#FFB600', index: 1 },
    name: 'Banana',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3269,
    _meta: { color: '#FFB600', index: 8 },
    name: 'Tropical',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3270,
    _meta: { color: '#FFB600', index: 6 },
    name: 'Peach',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3271,
    _meta: { color: '#FFB600', index: 3 },
    name: 'Coconut',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3272,
    _meta: { color: '#FFB600', index: 2 },
    name: 'Berry',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3273,
    _meta: { color: '#FFB600', index: 5 },
    name: 'Grape',
    description: '',
    _links: {
      type: {
        id: 3251,
        _meta: { color: '#FFB600' },
        name: 'Fruity',
        description: '',
      },
    },
  },
  {
    id: 3274,
    _meta: { color: '#EF4123', index: 7 },
    name: 'Vanilla',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3275,
    _meta: { color: '#EF4123', index: 3 },
    name: 'Clove',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3276,
    _meta: { color: '#EF4123', index: 4 },
    name: 'Cumin',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3277,
    _meta: { color: '#EF4123', index: 1 },
    name: 'Camphor',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3278,
    _meta: { color: '#EF4123', index: 6 },
    name: 'Spicy',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3279,
    _meta: { color: '#EF4123', index: 5 },
    name: 'Pungent',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3280,
    _meta: { color: '#EF4123', index: 2 },
    name: 'Cinnamon',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3281,
    _meta: { color: '#EF4123' },
    name: 'Anise',
    description: '',
    _links: {
      type: {
        id: 3252,
        _meta: { color: '#EF4123', index: 10 },
        name: 'Spicy',
        description: '',
      },
    },
  },
  {
    id: 3282,
    _meta: { color: '#009C4A', index: 3 },
    name: 'Green',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3283,
    _meta: { color: '#009C4A' },
    name: 'Cucumber',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3284,
    _meta: { color: '#009C4A', index: 1 },
    name: 'Fatty',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3285,
    _meta: { color: '#009C4A', index: 2 },
    name: 'Grass',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3286,
    _meta: { color: '#009C4A', index: 5 },
    name: 'Waxy',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3287,
    _meta: { color: '#009C4A', index: 4 },
    name: 'Oat Flakes',
    description: '',
    _links: {
      type: {
        id: 3253,
        _meta: { color: '#009C4A', index: 3 },
        name: 'Green',
        description: '',
      },
    },
  },
  {
    id: 3288,
    _meta: { color: '#8DC63F', index: 6 },
    name: 'Potato',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3289,
    _meta: { color: '#8DC63F', index: 4 },
    name: 'Mushroom',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3290,
    _meta: { color: '#8DC63F', index: 5 },
    name: 'Onion',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3291,
    _meta: { color: '#8DC63F' },
    name: 'Bell pepper',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3292,
    _meta: { color: '#8DC63F', index: 3 },
    name: 'Garlic',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3293,
    _meta: { color: '#8DC63F', index: 1 },
    name: 'Cabbage',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3294,
    _meta: { color: '#8DC63F', index: 2 },
    name: 'Celery',
    description: '',
    _links: {
      type: {
        id: 3254,
        _meta: { color: '#8DC63F', index: 5 },
        name: 'Vegetable',
        description: '',
      },
    },
  },
  {
    id: 3295,
    _meta: { color: '#377F8F', index: 1 },
    name: 'Mint',
    description: '',
    _links: {
      type: {
        id: 3255,
        _meta: { color: '#377F8F', index: 4 },
        name: 'Herbal',
        description: '',
      },
    },
  },
  {
    id: 3296,
    _meta: { color: '#377F8F' },
    name: 'Herbal',
    description: '',
    _links: {
      type: {
        id: 3255,
        _meta: { color: '#377F8F', index: 4 },
        name: 'Herbal',
        description: '',
      },
    },
  },
  {
    id: 3297,
    _meta: { color: '#377F8F', index: 2 },
    name: 'Thyme',
    description: '',
    _links: {
      type: {
        id: 3255,
        _meta: { color: '#377F8F', index: 4 },
        name: 'Herbal',
        description: '',
      },
    },
  },
  {
    id: 3298,
    _meta: { color: '#941C81' },
    name: 'Floral',
    description: '',
    _links: {
      type: {
        id: 3256,
        _meta: { color: '#941C81', index: 2 },
        name: 'Floral',
        description: '',
      },
    },
  },
  {
    id: 3299,
    _meta: { color: '#941C81', index: 3 },
    name: 'Rose',
    description: '',
    _links: {
      type: {
        id: 3256,
        _meta: { color: '#941C81', index: 2 },
        name: 'Floral',
        description: '',
      },
    },
  },
  {
    id: 3300,
    _meta: { color: '#941C81', index: 2 },
    name: 'Honey',
    description: '',
    _links: {
      type: {
        id: 3256,
        _meta: { color: '#941C81', index: 2 },
        name: 'Floral',
        description: '',
      },
    },
  },
  {
    id: 3301,
    _meta: { color: '#941C81', index: 1 },
    name: 'Geranium',
    description: '',
    _links: {
      type: {
        id: 3256,
        _meta: { color: '#941C81', index: 2 },
        name: 'Floral',
        description: '',
      },
    },
  },
  {
    id: 3302,
    _meta: { color: '#941C81', index: 4 },
    name: 'Violet',
    description: '',
    _links: {
      type: {
        id: 3256,
        _meta: { color: '#941C81', index: 2 },
        name: 'Floral',
        description: '',
      },
    },
  },
  {
    id: 3303,
    _meta: { color: '#673325', index: 4 },
    name: 'Popcorn',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3304,
    _meta: { color: '#673325', index: 3 },
    name: 'Malty',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3305,
    _meta: { color: '#673325' },
    name: 'Coffee',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3306,
    _meta: { color: '#673325', index: 5 },
    name: 'Roasted',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3307,
    _meta: { color: '#673325', index: 1 },
    name: 'Earthy',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3308,
    _meta: { color: '#673325', index: 2 },
    name: 'Fried',
    description: '',
    _links: {
      type: {
        id: 3257,
        _meta: { color: '#673325', index: 7 },
        name: 'Roasted',
        description: '',
      },
    },
  },
  {
    id: 3309,
    _meta: { color: '#DC6A02' },
    name: 'Caramel',
    description: '',
    _links: {
      type: {
        id: 3258,
        _meta: { color: '#DC6A02', index: 6 },
        name: 'Caramel',
        description: '',
      },
    },
  },
  {
    id: 3310,
    _meta: { color: '#DC6A02', index: 1 },
    name: 'Maple',
    description: '',
    _links: {
      type: {
        id: 3258,
        _meta: { color: '#DC6A02', index: 6 },
        name: 'Caramel',
        description: '',
      },
    },
  },
  {
    id: 3311,
    _meta: { color: '#D4A614', index: 1 },
    name: 'Nutty',
    description: '',
    _links: {
      type: {
        id: 3259,
        _meta: { color: '#D4A614', index: 8 },
        name: 'Nutty',
        description: '',
      },
    },
  },
  {
    id: 3312,
    _meta: { color: '#D4A614' },
    name: 'Hazelnut',
    description: '',
    _links: {
      type: {
        id: 3259,
        _meta: { color: '#D4A614', index: 8 },
        name: 'Nutty',
        description: '',
      },
    },
  },
  {
    id: 3313,
    _meta: { color: '#D4A614', index: 2 },
    name: 'Tonka',
    description: '',
    _links: {
      type: {
        id: 3259,
        _meta: { color: '#D4A614', index: 8 },
        name: 'Nutty',
        description: '',
      },
    },
  },
  {
    id: 3314,
    _meta: { color: '#FFCB05', index: 2 },
    name: 'Cheesy',
    description: '',
    _links: {
      type: {
        id: 3260,
        _meta: { color: '#FFCB05', index: 11 },
        name: 'Cheesy',
        description: '',
      },
    },
  },
  {
    id: 3315,
    _meta: { color: '#FFCB05' },
    name: 'Acidic',
    description: '',
    _links: {
      type: {
        id: 3260,
        _meta: { color: '#FFCB05', index: 11 },
        name: 'Cheesy',
        description: '',
      },
    },
  },
  {
    id: 3316,
    _meta: { color: '#FFCB05', index: 1 },
    name: 'Buttery',
    description: '',
    _links: {
      type: {
        id: 3260,
        _meta: { color: '#FFCB05', index: 11 },
        name: 'Cheesy',
        description: '',
      },
    },
  },
  {
    id: 3317,
    _meta: { color: '#FFCB05', index: 3 },
    name: 'Creamy',
    description: '',
    _links: {
      type: {
        id: 3260,
        _meta: { color: '#FFCB05', index: 11 },
        name: 'Cheesy',
        description: '',
      },
    },
  },
  {
    id: 3318,
    _meta: { color: '#9E4915', index: 3 },
    name: 'Smoky',
    description: '',
    _links: {
      type: {
        id: 3261,
        _meta: { color: '#9E4915', index: 9 },
        name: 'Woody',
        description: '',
      },
    },
  },
  {
    id: 3319,
    _meta: { color: '#9E4915', index: 4 },
    name: 'Woody',
    description: '',
    _links: {
      type: {
        id: 3261,
        _meta: { color: '#9E4915', index: 9 },
        name: 'Woody',
        description: '',
      },
    },
  },
  {
    id: 3320,
    _meta: { color: '#9E4915' },
    name: 'Balsamic',
    description: '',
    _links: {
      type: {
        id: 3261,
        _meta: { color: '#9E4915', index: 9 },
        name: 'Woody',
        description: '',
      },
    },
  },
  {
    id: 3321,
    _meta: { color: '#9E4915', index: 1 },
    name: 'Phenolic',
    description: '',
    _links: {
      type: {
        id: 3261,
        _meta: { color: '#9E4915', index: 9 },
        name: 'Woody',
        description: '',
      },
    },
  },
  {
    id: 3322,
    _meta: { color: '#9E4915', index: 2 },
    name: 'Pine',
    description: '',
    _links: {
      type: {
        id: 3261,
        _meta: { color: '#9E4915', index: 9 },
        name: 'Woody',
        description: '',
      },
    },
  },
  {
    id: 3323,
    _meta: { color: '#CEDC2F', index: 1 },
    name: 'Grapefruit',
    description: '',
    _links: {
      type: {
        id: 3262,
        _meta: { color: '#CEDC2F', index: 1 },
        name: 'Citrus',
        description: '',
      },
    },
  },
  {
    id: 3324,
    _meta: { color: '#CEDC2F', index: 3 },
    name: 'Orange',
    description: '',
    _links: {
      type: {
        id: 3262,
        _meta: { color: '#CEDC2F', index: 1 },
        name: 'Citrus',
        description: '',
      },
    },
  },
  {
    id: 3325,
    _meta: { color: '#CEDC2F' },
    name: 'Citrus',
    description: '',
    _links: {
      type: {
        id: 3262,
        _meta: { color: '#CEDC2F', index: 1 },
        name: 'Citrus',
        description: '',
      },
    },
  },
  {
    id: 3326,
    _meta: { color: '#CEDC2F', index: 2 },
    name: 'Lemon',
    description: '',
    _links: {
      type: {
        id: 3262,
        _meta: { color: '#CEDC2F', index: 1 },
        name: 'Citrus',
        description: '',
      },
    },
  },
  {
    id: 3327,
    _meta: { color: '#AD274E' },
    name: 'Animal',
    description: '',
    _links: {
      type: {
        id: 3263,
        _meta: { color: '#AD274E', index: 12 },
        name: 'Animal',
        description: '',
      },
    },
  },
  {
    id: 3328,
    _meta: { color: '#AD274E', index: 1 },
    name: 'Fishy',
    description: '',
    _links: {
      type: {
        id: 3263,
        _meta: { color: '#AD274E', index: 12 },
        name: 'Animal',
        description: '',
      },
    },
  },
  {
    id: 3329,
    _meta: { color: '#AD274E', index: 2 },
    name: 'Meaty',
    description: '',
    _links: {
      type: {
        id: 3263,
        _meta: { color: '#AD274E', index: 12 },
        name: 'Animal',
        description: '',
      },
    },
  },
  {
    id: 3330,
    _meta: { color: '#555951', index: 1 },
    name: 'Dusty',
    description: '',
    _links: {
      type: {
        id: 3264,
        _meta: { color: '#555951', index: 13 },
        name: 'Chemical',
        description: '',
      },
    },
  },
  {
    id: 3331,
    _meta: { color: '#555951', index: 4 },
    name: 'Solvent',
    description: '',
    _links: {
      type: {
        id: 3264,
        _meta: { color: '#555951', index: 13 },
        name: 'Chemical',
        description: '',
      },
    },
  },
  {
    id: 3332,
    _meta: { color: '#555951' },
    name: 'Burnt',
    description: '',
    _links: {
      type: {
        id: 3264,
        _meta: { color: '#555951', index: 13 },
        name: 'Chemical',
        description: '',
      },
    },
  },
  {
    id: 3333,
    _meta: { color: '#555951', index: 2 },
    name: 'Petroleum',
    description: '',
    _links: {
      type: {
        id: 3264,
        _meta: { color: '#555951', index: 13 },
        name: 'Chemical',
        description: '',
      },
    },
  },
  {
    id: 3334,
    _meta: { color: '#555951', index: 3 },
    name: 'Soapy',
    description: '',
    _links: {
      type: {
        id: 3264,
        _meta: { color: '#555951', index: 13 },
        name: 'Chemical',
        description: '',
      },
    },
  },
];

const Fruity$1 = '#FFB600';
const Citrus$1 = '#CEDC2F';
const Floral$1 = '#941C81';
const Green$1 = '#009C4A';
const Herbal$1 = '#377F8F';
const Vegetable$1 = '#8DC63F';
const Caramel$1 = '#DC6A02';
const Roasted$1 = '#673325';
const Nutty$1 = '#D4A614';
const Woody$1 = '#9E4915';
const Spicy$1 = '#EF4123';
const Cheesy$1 = '#FFCB05';
const Animal$1 = '#AD274E';
const Chemical$1 = '#555951';
const categoryColors = {
  Fruity: Fruity$1,
  Citrus: Citrus$1,
  Floral: Floral$1,
  Green: Green$1,
  Herbal: Herbal$1,
  Vegetable: Vegetable$1,
  Caramel: Caramel$1,
  Roasted: Roasted$1,
  Nutty: Nutty$1,
  Woody: Woody$1,
  Spicy: Spicy$1,
  Cheesy: Cheesy$1,
  Animal: Animal$1,
  Chemical: Chemical$1,
};

const QueryParameters = /* #__PURE__ */ _createClass(function QueryParameters() {
  _classCallCheck(this, QueryParameters);
});

QueryParameters.getParameterByName = function (name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]'.concat(name, '(=([^&#]*)|&|#|$)'));
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const cache = {
  defaults: {
    handle: new models.IngredientHandle({
      id: 6045,
      name: 'Adelscott',
    }),
    ingredient: null,
    taxonomy: null,
  },
  handles: null,
  ingredients: {},
  taxonomy: null,
  classification: null,
};
cache.ingredients[cache.defaults.handle.id] = cache.defaults.ingredient; /// FIXME: Patches for category colors

/**
 * AbstractView
 */

const _private$a = namespace();

const AbstractView = /* #__PURE__ */ (function () {
  function AbstractView() {
    _classCallCheck(this, AbstractView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    const _args = _construct(object.Arguments, args);

    _private$a(this).canvas = document.createElement('canvas');

    _private$a(this).canvas.setAttribute('class', _args.get('className') || 'main-view');

    _private$a(this).canvas.setAttribute('resize', 'true');

    _private$a(this).canvas.setAttribute('data-paper-resize', 'true');

    if (_args.get('hidpi')) {
      _private$a(this).canvas.setAttribute('hidpi', _args.get('hidpi'));
    }

    if (_args.get('hiddenCanvas') && _private$a(this).canvas) {
      _private$a(this).canvas.setAttribute('hidden', 'hidden');
    }

    if (_args.get('width') && _private$a(this).canvas);

    if (_args.get('height') && _private$a(this).canvas) {
      _private$a(this).canvas.setAttribute(
        'height',
        _args.get('width') >= args.get('height') ? args.get('height') : _args.get('width'),
      );

      console.log(_args.get('height'), _args.get('height'));
      _private$a(this).canvas.style.maxHeight = _args.get('width');
    }

    _private$a(this).ingredient = _args.get('ingredient');
    _private$a(this).taxonomy = _args.get('taxonomy');

    const id = _args.get('id');

    if (typeof id === 'string') {
      _private$a(this).canvas.setAttribute('id', id);
    }

    const parent = _args.get('parent');

    if (parent instanceof HTMLElement) {
      parent.appendChild(_private$a(this).canvas);
    }

    const backgroundColor = _args.get('backgroundColor');

    if (typeof backgroundColor === 'string') {
      _private$a(this).backgroundColor = backgroundColor;
    } else {
      _private$a(this).backgroundColor = '#ffffff';
    }

    _private$a(this).stale = true;
  }

  _createClass(AbstractView, [
    {
      key: 'exportPNG',
      value: function exportPNG() {
        return this.canvas.toDataURL();
      },
    },
    {
      key: 'update',
      value: function update(deltaTime) {},
    },
    {
      key: 'render',
      value: function render(context) {},
    },
    {
      key: 'getCanvas',
      value: function getCanvas() {
        return _private$a(this).canvas;
      },
    },
    {
      key: 'canvas',
      get: function get() {
        return _private$a(this).canvas;
      },
    },
    {
      key: 'isStale',
      get: function get() {
        return _private$a(this).stale;
      },
    },
    {
      key: 'stale',
      set: function set(newValue) {
        _private$a(this).stale = newValue;
      },
    },
    {
      key: 'height',
      get: function get() {
        return _private$a(this).canvas.height;
      },
    },
    {
      key: 'width',
      get: function get() {
        return _private$a(this).canvas.width;
      },
    },
    {
      key: 'updateIngredient',
      value: function updateIngredient(ingredient) {
        _private$a(this).ingredient = ingredient;
        this.stale = true;
      },
    },
    {
      key: 'updateTaxonomy',
      value: function updateTaxonomy(taxonomy) {
        _private$a(this).taxonomy = taxonomy;
        this.stale = true;
      },
    },
    {
      key: 'ingredient',
      get: function get() {
        return _private$a(this).ingredient;
      },
    },
    {
      key: 'taxonomy',
      get: function get() {
        return _private$a(this).taxonomy;
      },
    },
  ]);

  return AbstractView;
})();

const AbstractRenderer = /* #__PURE__ */ (function () {
  function AbstractRenderer() {
    _classCallCheck(this, AbstractRenderer);
  }

  _createClass(AbstractRenderer, [
    {
      key: 'attachView',
      value: function attachView(view) {
        console.assert(
          view instanceof AbstractView,
          'Expected a concrete subclass of AbstractView for view but instead got:',
          view,
        );
      },
    },
  ]);

  return AbstractRenderer;
})();

const fontMetrics = {
  'Helvetica Neue Light': {
    xHeight: 6.36,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.60394287109375,
    descent: 2.55596923828125,
  },
  'Helvetica Neue UltraLight Italic': {
    xHeight: 6.3,
    leading: 0.32391357421875,
    size: 12,
    ascent: 11.1719970703125,
    descent: 2.55596923828125,
  },
  'Helvetica Neue Bold': {
    xHeight: 6.204,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.7000732421875,
    descent: 2.60394287109375,
  },
  'Helvetica Neue Condensed Black': {
    xHeight: 6.636,
    leading: 0.33599853515625,
    size: 12,
    ascent: 11.66400146484375,
    descent: 2.72406005859375,
  },
  'Helvetica Neue Condensed Bold': {
    xHeight: 6.612,
    leading: 0.33599853515625,
    size: 12,
    ascent: 11.531982421875,
    descent: 2.65191650390625,
  },
  'Helvetica Neue Italic': {
    xHeight: 6.204,
    leading: 0.33599853515625,
    size: 12,
    ascent: 11.4840087890625,
    descent: 2.55596923828125,
  },
  'Helvetica Neue Thin': {
    xHeight: 6.168,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.60394287109375,
    descent: 2.55596923828125,
  },
  'Helvetica Neue Light Italic': {
    xHeight: 6.36,
    leading: 0.33599853515625,
    size: 12,
    ascent: 11.41204833984375,
    descent: 2.55596923828125,
  },
  'Helvetica Neue': {
    xHeight: 6.204,
    leading: 0.33599853515625,
    size: 12,
    ascent: 11.4239501953125,
    descent: 2.55596923828125,
  },
  'Helvetica Neue Bold Italic': {
    xHeight: 6.204,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.7000732421875,
    descent: 2.60394287109375,
  },
  'Helvetica Neue Medium': {
    xHeight: 6.204,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.7000732421875,
    descent: 2.60394287109375,
  },
  'Helvetica Neue UltraLight': {
    xHeight: 6.3,
    leading: 0.32391357421875,
    size: 12,
    ascent: 11.1719970703125,
    descent: 2.55596923828125,
  },
  'Helvetica Neue Medium Italic': {
    xHeight: 6.204,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.7000732421875,
    descent: 2.60394287109375,
  },
  'Helvetica Neue Thin Italic': {
    xHeight: 6.168,
    leading: 0.34808349609375,
    size: 12,
    ascent: 11.60394287109375,
    descent: 2.55596923828125,
  },
};

/**
 * ordefault()
 */
function ordefault(object, key, value) {
  return typeof object[key] === 'undefined' ? value : object[key];
}

/**
 * PaperFont
 */

const _private$9 = namespace();

const PaperFont = /* #__PURE__ */ (function () {
  function PaperFont() {
    const object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PaperFont);

    _private$9(this).fontFamily = ordefault(object, 'fontFamily', 'Helvetica Neue');
    _private$9(this).fontSize = ordefault(object, 'fontSize', 12);
    _private$9(this).fontWeight = ordefault(object, 'fontWeight', 'normal');
  }

  _createClass(PaperFont, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          fontFamily: this.fontFamily,
          fontSize: this.fontSize,
          fontWeight: this.fontWeight,
        };
      },
    },
    {
      key: 'fontFamily',
      get: function get() {
        return _private$9(this).fontFamily;
      },
    },
    {
      key: 'fontSize',
      get: function get() {
        return _private$9(this).fontSize;
      },
    },
    {
      key: 'fontWeight',
      get: function get() {
        return _private$9(this).fontWeight;
      },
    },
  ]);

  return PaperFont;
})();

/**
 * PaperStyle
 */

const _private$8 = namespace();

const PaperStyle = /* #__PURE__ */ (function () {
  function PaperStyle() {
    const object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PaperStyle);

    _private$8(this).fillColor = ordefault(object, 'fillColor', '#A0A0A0');
    _private$8(this).strokeCap = ordefault(object, 'strokeCap', 'butt');
    _private$8(this).strokeColor = ordefault(object, 'strokeColor', '#000000');
    _private$8(this).strokeJoin = ordefault(object, 'strokeJoin', 'miter');
    _private$8(this).strokeWidth = ordefault(object, 'strokeWidth', 1);
    _private$8(this).shadowBlur = ordefault(object, 'shadowBlur', 0);
    _private$8(this).shadowColor = ordefault(object, 'shadowColor', null);
    _private$8(this).shadowOffset = ordefault(object, 'shadowOffset', 0);
  }

  _createClass(PaperStyle, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          fillColor: this.fillColor,
          strokeCap: this.strokeCap,
          strokeColor: this.strokeColor,
          strokeJoin: this.strokeJoin,
          strokeWidth: this.strokeWidth,
          shadowBlur: this.shadowBlur,
          shadowColor: this.shadowColor,
          shadowOffset: this.shadowOffset,
        };
      },
    },
    {
      key: 'fillColor',
      get: function get() {
        return _private$8(this).fillColor;
      },
    },
    {
      key: 'strokeCap',
      get: function get() {
        return _private$8(this).strokeCap;
      },
    },
    {
      key: 'strokeColor',
      get: function get() {
        return _private$8(this).strokeColor;
      },
    },
    {
      key: 'strokeJoin',
      get: function get() {
        return _private$8(this).strokeJoin;
      },
    },
    {
      key: 'strokeWidth',
      get: function get() {
        return _private$8(this).strokeWidth;
      },
    },
    {
      key: 'shadowBlur',
      get: function get() {
        return _private$8(this).shadowBlur;
      },
    },
    {
      key: 'shadowColor',
      get: function get() {
        return _private$8(this).shadowColor;
      },
    },
    {
      key: 'shadowOffset',
      get: function get() {
        return _private$8(this).shadowOffset;
      },
    },
  ]);

  return PaperStyle;
})();

/**
 * PaperTypesetter
 */

const _private$7 = namespace();

const PaperTypesetter = /* #__PURE__ */ (function () {
  function PaperTypesetter() {
    const object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PaperTypesetter);

    _private$7(this).textAlignmentX = ordefault(object, 'textAlignmentX', 'left');
    _private$7(this).textAlignmentY = ordefault(object, 'textAlignmentY', 'baseline');
    _private$7(this).textLeading = ordefault(object, 'textLeading', 0.2);
  }

  _createClass(PaperTypesetter, [
    {
      key: 'toJSON',
      value: function toJSON() {
        return {
          textAlignmentX: this.textAlignmentX,
          textAlignmentY: this.textAlignmentY,
          textLeading: this.textLeading,
        };
      },
    },
    {
      key: 'textAlignmentX',
      get: function get() {
        return _private$7(this).textAlignmentX;
      },
    },
    {
      key: 'textAlignmentY',
      get: function get() {
        return _private$7(this).textAlignmentY;
      },
    },
    {
      key: 'textLeading',
      get: function get() {
        return _private$7(this).textLeading;
      },
    },
  ]);

  return PaperTypesetter;
})();

/**
 * PaperRenderer
 */

const _private$6 = namespace();

const _paperProject = function _paperProject(paperRenderer) {
  return paper__default.default.projects[_private$6(paperRenderer).index];
};

const PaperRenderer = /* #__PURE__ */ (function (_AbstractRenderer) {
  _inherits(PaperRenderer, _AbstractRenderer);

  const _super = _createSuper(PaperRenderer);

  function PaperRenderer() {
    let _this;

    _classCallCheck(this, PaperRenderer);

    _this = _super.call(this);
    _private$6(_assertThisInitialized(_this)).index = -1;
    _private$6(_assertThisInitialized(_this)).backgroundColor = '#ffffff';
    _private$6(_assertThisInitialized(_this)).fonts = [];
    _private$6(_assertThisInitialized(_this)).styles = [];
    _private$6(_assertThisInitialized(_this)).typesetters = [];
    return _this;
  }

  _createClass(PaperRenderer, [
    {
      key: 'attachView',
      value: function attachView(view) {
        _get(_getPrototypeOf(PaperRenderer.prototype), 'attachView', this).call(this, view); /// Reset fonts, styles, and typesetter

        this.pushFont(new PaperFont());
        this.pushStyle(new PaperStyle());
        this.pushTypesetter(new PaperTypesetter()); /// Set the project index

        _private$6(this).index = paper__default.default.projects.length; /// Create a new document for the view's canvas

        paper__default.default.setup(view.canvas);

        const v = _paperProject(this).view; // trick to scale - fix text overlapping

        const scaleRatio = v.pixelRatio <= 1 ? v.pixelRatio * 1.25 : v.pixelRatio;
        v.scale(1 / scaleRatio); /// Attach view callbacks

        _paperProject(this).view.onFrame = function (event) {
          view.update(1000 * event.delta);

          if (view.isStale) {
            _paperProject(this).activate();

            _paperProject(this).activeLayer.removeChildren(); /// Clear the background

            const fillColor = view.backgroundColor;
            new paper__default.default.Path.Rectangle({
              point: [0, 0],
              // size: [view.width, view.height],
              strokeColor: null,
              fillColor,
            }); /// Clear the stacks (avoids unbalanced push/pop)

            _private$6(this).fonts = [];
            _private$6(this).styles = [];
            _private$6(this).typesetters = []; /// Push default fonts, styles, and typesetter

            this.pushFont(new PaperFont());
            this.pushStyle(new PaperStyle());
            this.pushTypesetter(new PaperTypesetter());
            view.render(this);
            view.stale = false;
          }
        }.bind(this);
      },
    },
    {
      key: 'getView',
      value: function getView() {
        return _paperProject(this).view;
      },
    },
    {
      key: 'getProject',
      value: function getProject() {
        return _paperProject(this);
      },
    },
    {
      key: 'createGrayColor',
      value: function createGrayColor(color) {
        const c = new paper__default.default.Color(color);
        return {
          gray: c.gray,
          alpha: c.alpha,
        };
      },
    },
    {
      key: 'createHSBColor',
      value: function createHSBColor(color) {
        const c = new paper__default.default.Color(color);
        return {
          hue: c.hue,
          saturation: c.saturation,
          brightness: c.brightness,
          alpha: c.alpha,
        };
      },
    },
    {
      key: 'createHSBColorSpectrum',
      value: function createHSBColorSpectrum(baseColor, sampleCount) {
        const color = new paper__default.default.Color(baseColor);
        const { saturation } = color;
        const { brightness } = color;
        const deltaSaturation = saturation / (sampleCount + 1);
        const deltaBrightness = (1.0 - brightness) / (sampleCount + 1);
        const spectrum = [];

        for (let i = 0; i < sampleCount; i++) {
          color.brightness = brightness + (i + 1) * deltaBrightness;
          color.saturation = saturation - (i + 1) * deltaSaturation;
          spectrum.push(this.createHSBColor(color));
        }

        return spectrum;
      },
    },
    {
      key: 'createRGBColor',
      value: function createRGBColor(color) {
        const c = new paper__default.default.Color(color);
        return {
          red: c.red,
          green: c.green,
          blue: c.blue,
          alpha: c.alpha,
        };
      },
    },
    {
      key: 'drawBezierLineSector',
      value: function drawBezierLineSector(x, y, innerRadius, innerAngle, outerRadius, outerAngle, controlWeight) {
        const object = this.currentStyle.toJSON();
        const path = new paper__default.default.Path(object);
        const p1 = new paper__default.default.Point(
          innerRadius * Math.cos(innerAngle) + x,
          innerRadius * Math.sin(innerAngle) + y,
        );
        let c1 = new paper__default.default.Point(
          outerRadius * Math.cos(innerAngle) + x,
          outerRadius * Math.sin(innerAngle) + y,
        );
        c1 = Tween.lerpPoint(c1, p1, 1.0 - controlWeight);
        c1 = new paper__default.default.Point(c1.x, c1.y);
        const p2 = new paper__default.default.Point(
          outerRadius * Math.cos(outerAngle) + x,
          outerRadius * Math.sin(outerAngle) + y,
        );
        let c2 = new paper__default.default.Point(
          innerRadius * Math.cos(innerAngle) + x,
          innerRadius * Math.sin(innerAngle) + y,
        );
        c2 = Tween.lerpPoint(c2, p2, 1.0 - controlWeight);
        c2 = new paper__default.default.Point(c2.x, c2.y);
        path.moveTo(p1);
        path.cubicCurveTo(c1, c2, p2);
      },
      /**
       * --- (x2, y2) --(c2)-----(c3)-- (x3, y3) ---
       *   |            {bezier here}            |
       * --- (x1, y1) --(c1)-----(c4)-- (x4, y4) ---
       *
       */
    },
    {
      key: 'drawBezierBand',
      value: function drawBezierBand(x1, y1, x2, y2, x3, y3, x4, y4, controlWeight) {
        const object = this.currentStyle.toJSON();
        object.closed = true;
        const path = new paper__default.default.Path(object);
        const p1 = new paper__default.default.Point(x1, y1);
        const p2 = new paper__default.default.Point(x2, y2);
        const p3 = new paper__default.default.Point(x3, y3);
        const p4 = new paper__default.default.Point(x4, y4);
        const c1x = Tween.lerpNumber(x1, x4, 1.0 - controlWeight);
        const c1 = new paper__default.default.Point(c1x, y1);
        const c2x = Tween.lerpNumber(x2, x3, 1.0 - controlWeight);
        const c2 = new paper__default.default.Point(c2x, y2);
        const c3x = Tween.lerpNumber(x3, x2, 1.0 - controlWeight);
        const c3 = new paper__default.default.Point(c3x, y3);
        const c4x = Tween.lerpNumber(x4, x1, 1.0 - controlWeight);
        const c4 = new paper__default.default.Point(c4x, y4);
        path.moveTo(p1);
        path.lineTo(p2);
        path.cubicCurveTo(c2, c3, p3);
        path.lineTo(p4);
        path.cubicCurveTo(c4, c1, p1);
      },
    },
    {
      key: 'drawBezierSector',
      value: function drawBezierSector(
        x,
        y,
        innerRadius,
        innerStartAngle,
        innerStopAngle,
        outerRadius,
        outerStartAngle,
        outerStopAngle,
        controlWeight,
      ) {
        const object = this.currentStyle.toJSON();
        object.closed = true;
        const path = new paper__default.default.Path(object);
        const innerHalfAngle = (innerStartAngle + innerStopAngle) / 2;
        const outerHalfAngle = (outerStartAngle + outerStopAngle) / 2;
        const p1 = new paper__default.default.Point(
          innerRadius * Math.cos(innerStartAngle) + x,
          innerRadius * Math.sin(innerStartAngle) + y,
        );
        const p12 = new paper__default.default.Point(
          innerRadius * Math.cos(innerHalfAngle) + x,
          innerRadius * Math.sin(innerHalfAngle) + y,
        );
        const p2 = new paper__default.default.Point(
          innerRadius * Math.cos(innerStopAngle) + x,
          innerRadius * Math.sin(innerStopAngle) + y,
        );
        const p3 = new paper__default.default.Point(
          outerRadius * Math.cos(outerStopAngle) + x,
          outerRadius * Math.sin(outerStopAngle) + y,
        );
        const p34 = new paper__default.default.Point(
          outerRadius * Math.cos(outerHalfAngle) + x,
          outerRadius * Math.sin(outerHalfAngle) + y,
        );
        const p4 = new paper__default.default.Point(
          outerRadius * Math.cos(outerStartAngle) + x,
          outerRadius * Math.sin(outerStartAngle) + y,
        );
        let c2 = new paper__default.default.Point(
          outerRadius * Math.cos(innerStopAngle) + x,
          outerRadius * Math.sin(innerStopAngle) + y,
        );
        c2 = Tween.lerpPoint(c2, p2, 1.0 - controlWeight);
        c2 = new paper__default.default.Point(c2.x, c2.y);
        let c3 = new paper__default.default.Point(
          innerRadius * Math.cos(outerStopAngle) + x,
          innerRadius * Math.sin(outerStopAngle) + y,
        );
        c3 = Tween.lerpPoint(c3, p3, 1.0 - controlWeight);
        c3 = new paper__default.default.Point(c3.x, c3.y);
        let c4 = new paper__default.default.Point(
          innerRadius * Math.cos(outerStartAngle) + x,
          innerRadius * Math.sin(outerStartAngle) + y,
        );
        c4 = Tween.lerpPoint(c4, p4, 1.0 - controlWeight);
        c4 = new paper__default.default.Point(c4.x, c4.y);
        let c1 = new paper__default.default.Point(
          outerRadius * Math.cos(innerStartAngle) + x,
          outerRadius * Math.sin(innerStartAngle) + y,
        );
        c1 = Tween.lerpPoint(c1, p1, 1.0 - controlWeight);
        c1 = new paper__default.default.Point(c1.x, c1.y);
        path.moveTo(p1);
        path.arcTo(p12, p2);
        path.cubicCurveTo(c2, c3, p3);
        path.arcTo(p34, p4);
        path.cubicCurveTo(c4, c1, p1);
      },
    },
    {
      key: 'drawCircle',
      value: function drawCircle(x, y, radius) {
        const object = this.currentStyle.toJSON();
        object.center = [x, y];
        object.radius = radius;
        new paper__default.default.Path.Circle(object);
      },
    },
    {
      key: 'drawEllipse',
      value: function drawEllipse(x, y, radiusX, radiusY) {
        const object = this.currentStyle.toJSON();
        object.center = [x, y];
        object.size = [radiusX, radiusY];
        new paper__default.default.Path.Ellipse(object);
      },
    },
    {
      key: 'drawLine',
      value: function drawLine(x1, y1, x2, y2) {
        const object = this.currentStyle.toJSON();
        object.from = [x1, y1];
        object.to = [x2, y2];
        new paper__default.default.Path.Line(object);
      },
    },
    {
      key: 'drawRectangle',
      value: function drawRectangle(x, y, width, height) {
        const object = this.currentStyle.toJSON();
        object.point = [x, y];
        object.size = [width, height];
        new paper__default.default.Path.Rectangle(object);
      },
    },
    {
      key: 'drawRingSector',
      value: function drawRingSector(x, y, innerRadius, outerRadius, startAngle, stopAngle) {
        const object = this.currentStyle.toJSON();
        object.closed = true;
        const path = new paper__default.default.Path(object);
        const halfAngle = (startAngle + stopAngle) / 2;
        const start = new paper__default.default.Point(
          outerRadius * Math.cos(startAngle) + x,
          outerRadius * Math.sin(startAngle) + y,
        );
        let point1 = start.clone();
        let point2 = new paper__default.default.Point(
          outerRadius * Math.cos(halfAngle) + x,
          outerRadius * Math.sin(halfAngle) + y,
        );
        let point3 = new paper__default.default.Point(
          outerRadius * Math.cos(stopAngle) + x,
          outerRadius * Math.sin(stopAngle) + y,
        );

        try {
          path.moveTo(point1);
          path.arcTo(point2, point3);
        } catch (e) {
          console.log(e);
        }

        point1 = new paper__default.default.Point(
          innerRadius * Math.cos(stopAngle) + x,
          innerRadius * Math.sin(stopAngle) + y,
        );
        point2 = new paper__default.default.Point(
          innerRadius * Math.cos(halfAngle) + x,
          innerRadius * Math.sin(halfAngle) + y,
        );
        point3 = new paper__default.default.Point(
          innerRadius * Math.cos(startAngle) + x,
          innerRadius * Math.sin(startAngle) + y,
        );

        try {
          path.lineTo(point1);
          path.arcTo(point2, point3);
          path.lineTo(start);
        } catch (e) {
          console.log(e);
        }
      },
    },
    {
      key: 'drawText',
      value: function drawText(content, x, y) {
        const rotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        const alignmentY = this.currentTypesetter.textAlignmentY;
        const { fontFamily } = this.currentFont;
        const { fontSize } = this.currentFont;
        const fontMetric = fontMetrics[fontFamily] || {};
        const fontAscent = fontMetric.ascent || 0.66 * fontSize;
        const fontDescent = fontMetric.descent || 0.33 * fontSize;
        let yy = y;

        if (alignmentY == 'top') {
          yy += fontAscent;
        } else if (alignmentY == 'center') {
          yy += (fontAscent - fontDescent) / 2;
        } else if (alignmentY == 'bottom') {
          yy -= fontDescent;
        } else;

        const textLeading = fontMetric.leading || this.currentTypesetter.textLeading;
        const leading = (1 + textLeading) * fontSize;
        const justification = this.currentTypesetter.textAlignmentX;
        const object = Object.assign(this.currentFont.toJSON(), this.currentStyle.toJSON());
        object.content = content;
        object.justification = justification;
        object.leading = leading;
        object.point = [x, yy];
        const path = new paper__default.default.PointText(object); /// FIXME: Rotation should be part of a PaperTransform

        path.rotate((180 / Math.PI) * rotation, new paper__default.default.Point(x, y));
      },
    },
    {
      key: 'exportSVG',
      value: function exportSVG(options) {
        return _paperProject(this).exportSVG(options);
      },
    },
    {
      key: 'pushFont',
      value: function pushFont(object) {
        _private$6(this).fonts.push(new PaperFont(object));
      },
    },
    {
      key: 'pushStyle',
      value: function pushStyle(object) {
        _private$6(this).styles.push(new PaperStyle(object));
      },
    },
    {
      key: 'pushTypesetter',
      value: function pushTypesetter(object) {
        _private$6(this).typesetters.push(new PaperTypesetter(object));
      },
    },
    {
      key: 'popFont',
      value: function popFont() {
        return _private$6(this).fonts.pop();
      },
    },
    {
      key: 'popStyle',
      value: function popStyle() {
        return _private$6(this).styles.pop();
      },
    },
    {
      key: 'popTypesetter',
      value: function popTypesetter() {
        return _private$6(this).typesetters.pop();
      },
    },
    {
      key: 'currentFont',
      get: function get() {
        return _private$6(this).fonts[_private$6(this).fonts.length - 1];
      },
    },
    {
      key: 'currentStyle',
      get: function get() {
        return _private$6(this).styles[_private$6(this).styles.length - 1];
      },
    },
    {
      key: 'currentTypesetter',
      get: function get() {
        return _private$6(this).typesetters[_private$6(this).typesetters.length - 1];
      },
    },
  ]);

  return PaperRenderer;
})(AbstractRenderer);

const renderers = {
  PaperRenderer,
};

const renderer = renderers.PaperRenderer;

/**
 * IngredientViewV1
 */

const _private$5 = namespace();

const IngredientViewV1 = /* #__PURE__ */ (function (_object$definePropert) {
  _inherits(IngredientViewV1, _object$definePropert);

  const _super = _createSuper(IngredientViewV1);

  function IngredientViewV1() {
    let _this;

    _classCallCheck(this, IngredientViewV1);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    const _args = _construct(object.Arguments, args);

    _private$5(_assertThisInitialized(_this)).ingredient = _args.get('ingredient');
    _private$5(_assertThisInitialized(_this)).taxonomy = _args.get('taxonomy');
    return _this;
  }

  _createClass(IngredientViewV1, [
    {
      key: 'computeFontSize',
      value: function computeFontSize(unit) {
        if (unit <= 0.35) {
          return this.textFontSizeSmall;
        }

        if (unit > 0.35 && unit <= 0.7) {
          return this.textFontSizeMedium;
        }

        return this.textFontSizeLarge;
      },
    },
    {
      key: 'computeTextAlignment',
      value: function computeTextAlignment(angle) {
        const isInnerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        while (angle < 0) {
          angle += 2 * Math.PI;
        }

        const a1 = Math.PI / 4;
        const a2 = a1 + Math.PI / 2;
        const a3 = a2 + Math.PI / 2;
        const a4 = a3 + Math.PI / 2;

        if (a1 < angle && angle <= a2) {
          /// Bottom
          return {
            x: 'center',
            y: isInnerText ? 'bottom' : 'top',
          };
        }

        if (a2 < angle && angle <= a3) {
          /// Left
          return {
            x: isInnerText ? 'left' : 'right',
            y: 'center',
          };
        }

        if (a3 < angle && angle <= a4) {
          /// Top
          return {
            x: 'center',
            y: isInnerText ? 'top' : 'bottom',
          };
        } /// Right

        return {
          x: isInnerText ? 'right' : 'left',
          y: 'center',
        };
      },
    },
    {
      key: 'didSetMinimumWeight',
      value: function didSetMinimumWeight(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryRadius',
      value: function didSetCategoryRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategorySpacer',
      value: function didSetCategorySpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextRadius',
      value: function didSetCategoryTextRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorRadius',
      value: function didSetDescriptorRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorSpacer',
      value: function didSetDescriptorSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextRadius',
      value: function didSetDescriptorTextRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetInnerRadius',
      value: function didSetInnerRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLineColor',
      value: function didSetLineColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLineWidth',
      value: function didSetLineWidth(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextColor',
      value: function didSetTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextFont',
      value: function didSetTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextFontSizeSmall',
      value: function didSetTextFontSizeSmall(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextFontSizeMedium',
      value: function didSetTextFontSizeMedium(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextFontSizeLarge',
      value: function didSetTextFontSizeLarge(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'render',
      value: function render(context) {
        /// Draw some stuff
        const _private2 = _private$5(this);
        const { ingredient } = _private2;

        const { categoryCount } = ingredient;
        ingredient.descriptorCount;
        const totalCategorySpacer = categoryCount * this.categorySpacer;
        const totalCategoryAngle = 2 * Math.PI - totalCategorySpacer;
        let startCategoryAngle = -Math.PI / 2;
        const { lineColor } = this;
        const { lineWidth } = this;
        const { textColor } = this;
        const fontFamily = this.textFont;

        for (let cindex = 0; cindex < ingredient.categoryCount; cindex++) {
          const category = ingredient.getCategoryByIndex(cindex);
          const categoryTotal = ingredient.getTotalAromaValueForCategory(category);
          const weightedValue = categoryTotal / ingredient.totalAromaValue;
          const currentCategoryAngle = weightedValue * totalCategoryAngle; // skip when too small

          if (categoryTotal < this.minimumWeight) {
            /// Advance angle to next category
            startCategoryAngle += currentCategoryAngle + this.categorySpacer;
            continue;
          } /// Inner ring

          context.pushStyle({
            fillColor: category.color,
            strokeColor: null,
          });

          try {
            context.drawRingSector(
              this.width / 2,
              this.height / 2,
              this.innerRadius,
              this.categoryRadius,
              startCategoryAngle,
              startCategoryAngle + currentCategoryAngle,
            );
          } catch (e) {
            console.trace(e);
          }

          context.pushStyle(); /// Inner text

          let textAngle = startCategoryAngle + currentCategoryAngle / 2;
          let textRadius = this.categoryTextRadius;
          let textX = textRadius * Math.cos(textAngle) + this.width / 2;
          let textY = textRadius * Math.sin(textAngle) + this.height / 2;
          let textAlignment = this.computeTextAlignment(textAngle, true);
          let fontSize = this.computeFontSize(categoryTotal / ingredient.maxCategoryValue);
          context.pushFont({
            fontFamily,
            fontSize,
            fontWeight: 'normal',
          });
          context.pushStyle({
            fillColor: textColor,
            strokeColor: null,
          });
          context.pushTypesetter({
            textAlignmentX: textAlignment.x,
            textAlignmentY: textAlignment.y,
          });
          let textValue = category.name.toLowerCase();
          context.drawText(textValue, textX, textY);
          context.popTypesetter();
          context.popStyle();
          context.popFont(); /// Outer line

          let lineX1 = 1.04 * this.categoryTextRadius * Math.cos(textAngle) + this.width / 2;
          let lineY1 = 1.04 * this.categoryTextRadius * Math.sin(textAngle) + this.height / 2;
          let lineX2 = 0.96 * this.innerRadius * Math.cos(textAngle) + this.width / 2;
          let lineY2 = 0.96 * this.innerRadius * Math.sin(textAngle) + this.height / 2;
          context.pushStyle({
            strokeColor: lineColor,
            strokeWidth: lineWidth,
          });
          context.drawLine(lineX1, lineY1, lineX2, lineY2);
          context.popStyle();
          const aromas = ingredient.getAromasForCategory(category);
          let startDescriptorAngle = startCategoryAngle;
          const totalDescriptorAngle = currentCategoryAngle - (aromas.length - 1) * this.descriptorSpacer;
          const aromaColors = context.createHSBColorSpectrum(category.color, aromas.length);

          for (let aindex = 0; aindex < aromas.length; aindex++) {
            const aroma = aromas[aindex];
            const { descriptor } = aroma;

            const _weightedValue = aroma.value / categoryTotal;

            const currentDescriptorAngle = _weightedValue * totalDescriptorAngle; // skip when too small

            if (aroma.value < this.minimumWeight) {
              /// Advance angle to next descriptor
              startDescriptorAngle += currentDescriptorAngle + this.descriptorSpacer;
              continue;
            } /// Outer ring

            const scaledValue = aroma.value / ingredient.maxAromaValue;
            const scaledOuterRadius = this.categoryRadius + scaledValue * (this.descriptorRadius - this.categoryRadius);
            context.pushStyle({
              fillColor: aromaColors[aindex],
              strokeColor: null,
            });
            context.drawRingSector(
              this.width / 2,
              this.height / 2,
              this.categoryRadius,
              scaledOuterRadius,
              startDescriptorAngle,
              startDescriptorAngle + currentDescriptorAngle,
            );
            context.popStyle(); /// Outer text

            textRadius = this.descriptorTextRadius;
            textAngle = startDescriptorAngle + currentDescriptorAngle / 2;
            textX = textRadius * Math.cos(textAngle) + this.width / 2;
            textY = textRadius * Math.sin(textAngle) + this.height / 2;
            textAlignment = this.computeTextAlignment(textAngle, false);
            fontSize = this.computeFontSize(scaledValue);
            context.pushFont({
              fontFamily,
              fontSize,
              fontWeight: 'normal',
            });
            context.pushStyle({
              fillColor: textColor,
              strokeColor: null,
            });
            context.pushTypesetter({
              textAlignmentX: textAlignment.x,
              textAlignmentY: textAlignment.y,
            });
            textValue = descriptor.name.toLowerCase();
            context.drawText(textValue, textX, textY);
            context.popTypesetter();
            context.popStyle();
            context.popFont(); /// Outer line

            lineX1 = 1.02 * scaledOuterRadius * Math.cos(textAngle) + this.width / 2;
            lineY1 = 1.02 * scaledOuterRadius * Math.sin(textAngle) + this.height / 2;
            lineX2 = 0.98 * this.descriptorTextRadius * Math.cos(textAngle) + this.width / 2;
            lineY2 = 0.98 * this.descriptorTextRadius * Math.sin(textAngle) + this.height / 2;
            context.pushStyle({
              strokeColor: lineColor,
              strokeWidth: lineWidth,
            });
            context.drawLine(lineX1, lineY1, lineX2, lineY2);
            context.popStyle(); /// Advance angle to next descriptor

            startDescriptorAngle += currentDescriptorAngle + this.descriptorSpacer;
          } /// Advance angle to next category

          startCategoryAngle += currentCategoryAngle + this.categorySpacer;
        }
      },
    },
    {
      key: 'update',
      value: function update(deltaTime) {},
    },
    {
      key: 'updateIngredient',
      value: function updateIngredient(ingredient) {
        _private$5(this).ingredient = ingredient;
        this.stale = true;
      },
    },
    {
      key: 'ingredient',
      get: function get() {
        return _private$5(this).ingredient;
      },
    },
  ]);

  return IngredientViewV1;
})(
  object.defineProperties(
    AbstractView,
    new object.ObservedProperty('minimumWeight', 0.001),
    new object.ObservedProperty('categoryRadius', 300),
    new object.ObservedProperty('categorySpacer', 0.0),
    new object.ObservedProperty('categoryTextRadius', 150),
    new object.ObservedProperty('descriptorRadius', 480),
    new object.ObservedProperty('descriptorSpacer', 0.0),
    new object.ObservedProperty('descriptorTextRadius', 500),
    new object.ObservedProperty('innerRadius', 200),
    new object.ObservedProperty('lineColor', '#808080'),
    new object.ObservedProperty('lineWidth', 0.25),
    new object.ObservedProperty('textColor', '#666766'),
    new object.ObservedProperty('textFont', 'Helvetica Neue Medium'),
    new object.ObservedProperty('textFontSizeSmall', 16),
    new object.ObservedProperty('textFontSizeMedium', 26),
    new object.ObservedProperty('textFontSizeLarge', 36),
  ),
);

/**
 * CustomIngredientViewV1
 */

const CustomIngredientViewV1 = /* #__PURE__ */ (function (_IngredientViewV) {
  _inherits(CustomIngredientViewV1, _IngredientViewV);

  const _super = _createSuper(CustomIngredientViewV1);

  function CustomIngredientViewV1() {
    _classCallCheck(this, CustomIngredientViewV1);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  _createClass(CustomIngredientViewV1, [
    {
      key: 'ingredientJSON',
      get: function get() {
        return JSON.stringify(this.ingredient, null, '  ');
      },
      set: function set(newValue) {
        this.updateIngredient(newValue);
        this.stale = true;
      },
    },
  ]);

  return CustomIngredientViewV1;
})(IngredientViewV1);

const textFont$1 = 'Helvetica Neue Medium';
const textColor$1 = '#000000';
const inactiveColor$1 = '#e4e4e4';
const rotationInDegrees$1 = -90;
const categoryHeight$1 = 6;
const categoryRadius$1 = 120;
const categoryTextSize$1 = 11;
const categoryTextSpacer$1 = 12;
const descriptorHeightIsVariable$1 = true;
const descriptorHeightAnchor$1 = 'inner';
const descriptorHeightFixed$1 = 10;
const descriptorHeightMaximum$1 = 32;
const descriptorHeightMinimum$1 = 4;
const descriptorRadiusInner$1 = 240;
const descriptorRadiusOuter$1 = 480;
const descriptorSpacerInDegrees$1 = 2;
const descriptorTextSizeMaximum$1 = 18;
const descriptorTextSizeMinimum$1 = 8;
const descriptorTextSpacer$1 = 9;
const gradientIsVisible$1 = true;
const gradientCurveWeight$1 = 0.5;
const gradientOpacityIsVariable$1 = true;
const gradientOpacityInner$1 = 0.2;
const gradientOpacityOuter$1 = 0.5;
const totalDegrees$1 = 360;
const defaultV2ViewValues = {
  textFont: textFont$1,
  textColor: textColor$1,
  inactiveColor: inactiveColor$1,
  rotationInDegrees: rotationInDegrees$1,
  categoryHeight: categoryHeight$1,
  categoryRadius: categoryRadius$1,
  categoryTextSize: categoryTextSize$1,
  categoryTextSpacer: categoryTextSpacer$1,
  descriptorHeightIsVariable: descriptorHeightIsVariable$1,
  descriptorHeightAnchor: descriptorHeightAnchor$1,
  descriptorHeightFixed: descriptorHeightFixed$1,
  descriptorHeightMaximum: descriptorHeightMaximum$1,
  descriptorHeightMinimum: descriptorHeightMinimum$1,
  descriptorRadiusInner: descriptorRadiusInner$1,
  descriptorRadiusOuter: descriptorRadiusOuter$1,
  descriptorSpacerInDegrees: descriptorSpacerInDegrees$1,
  descriptorTextSizeMaximum: descriptorTextSizeMaximum$1,
  descriptorTextSizeMinimum: descriptorTextSizeMinimum$1,
  descriptorTextSpacer: descriptorTextSpacer$1,
  gradientIsVisible: gradientIsVisible$1,
  gradientCurveWeight: gradientCurveWeight$1,
  gradientOpacityIsVariable: gradientOpacityIsVariable$1,
  gradientOpacityInner: gradientOpacityInner$1,
  gradientOpacityOuter: gradientOpacityOuter$1,
  totalDegrees: totalDegrees$1,
};

/**
 * IngredientViewV2
 */

const _private$4 = namespace();

const convertDegreesToRadians = function convertDegreesToRadians(degrees) {
  return (Math.PI * degrees) / 180.0;
};

const standardizeAngle = function standardizeAngle(angle) {
  while (angle < 0) {
    angle += 2 * Math.PI;
  }

  while (angle > 2 * Math.PI) {
    angle -= 2 * Math.PI;
  }

  return angle;
};

const IngredientViewV2 = /* #__PURE__ */ (function (_object$definePropert) {
  _inherits(IngredientViewV2, _object$definePropert);

  const _super = _createSuper(IngredientViewV2);

  function IngredientViewV2() {
    let _this;

    _classCallCheck(this, IngredientViewV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    const _args = _construct(object.Arguments, args);

    _private$4(_assertThisInitialized(_this)).ingredient = _args.get('ingredient');
    _private$4(_assertThisInitialized(_this)).taxonomy = _args.get('taxonomy');
    return _this;
  }

  _createClass(IngredientViewV2, [
    {
      key: 'computeStartAngle',
      value: function computeStartAngle() {
        const _private2 = _private$4(this);
        const { ingredient } = _private2;

        const _private3 = _private$4(this);
        const { taxonomy } = _private3;

        const totalAngle = convertDegreesToRadians(this.totalDegrees);
        const descriptorSpacerRadians = convertDegreesToRadians(this.descriptorSpacerInDegrees);
        const totalCategoryAngle = totalAngle;
        const totalDescriptorAngle = totalAngle - ingredient.descriptorCount * descriptorSpacerRadians;
        const anglePerCategory = totalCategoryAngle / taxonomy.categoryCount;
        let startCategoryAngle = 0;
        let startDescriptorAngle = 0;
        const categoryAngles = {};
        const categoryLookup = {};
        const descriptorAngles = {}; /// Calculate and store initial angles

        for (let cindex = 0; cindex < taxonomy.categoryCount; cindex++) {
          const category = taxonomy.getCategoryByIndex(cindex);

          if (ingredient.getCategoryByName(category.name)) {
            categoryAngles[category.name] = startCategoryAngle + anglePerCategory / 2;
            ingredient.getAromasForCategory(category);

            const _iterator = _createForOfIteratorHelper(ingredient.getAromasForCategory(category));
            var _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                const aroma = _step.value;
                const { descriptor } = aroma;
                const descriptorWeight = aroma.value / ingredient.totalAromaValue;
                const descriptorAngle = descriptorWeight * totalDescriptorAngle;
                categoryLookup[descriptor.name] = category.name;
                descriptorAngles[descriptor.name] = startDescriptorAngle + descriptorAngle / 2; /// Advance angle to next descriptor

                startDescriptorAngle += descriptorAngle + descriptorSpacerRadians;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } /// Advance to the next category

          startCategoryAngle += anglePerCategory;
        } /// Compute a least squares estimation

        const leastSquaresEstimate = function leastSquaresEstimate(offsetAngle) {
          let estimate = 0.0;

          for (let _i = 0, _Object$keys = Object.keys(descriptorAngles); _i < _Object$keys.length; _i++) {
            const name = _Object$keys[_i];
            const categoryAngle = categoryAngles[categoryLookup[name]];

            const _descriptorAngle = descriptorAngles[name] + offsetAngle;

            const cmdAngle = standardizeAngle(categoryAngle - _descriptorAngle);
            const dmcAngle = standardizeAngle(_descriptorAngle - categoryAngle);
            estimate += Math.min(cmdAngle, dmcAngle) ** 2;
          }

          return estimate;
        }; /// FIXME: Dumb and iterative now; Should be recursive with tolerance

        const N = 720;
        let index = 0;
        let value = leastSquaresEstimate(0.0);

        for (let i = 1; i < N; i++) {
          const current = leastSquaresEstimate((2 * Math.PI * i) / N);

          if (current < value) {
            value = current;
            index = i;
          }
        }

        return (2 * Math.PI * index) / N;
      },
    },
    {
      key: 'computeTextAlignment',
      value: function computeTextAlignment(angle, onArc) {
        const a = standardizeAngle(angle);

        if (onArc) {
          return {
            x: 'center',
            y: 'bottom',
          };
        }

        if (Math.PI / 2 < a && a < (3 * Math.PI) / 2) {
          return {
            x: 'right',
            y: 'center',
          };
        }

        return {
          x: 'left',
          y: 'center',
        };
      },
    },
    {
      key: 'computeTextRotation',
      value: function computeTextRotation(angle, onArc) {
        const a = standardizeAngle(angle);

        if (onArc) {
          return Math.atan2(Math.sin(a), Math.cos(a)) + Math.PI / 2;
        }

        if (Math.PI / 2 < a && a < (3 * Math.PI) / 2) {
          return Math.atan2(Math.sin(a), Math.cos(a)) - Math.PI;
        }

        return Math.atan2(Math.sin(a), Math.cos(a));
      },
    },
    {
      key: 'computeTextSize',
      value: function computeTextSize(unit) {
        const range = this.descriptorTextSizeMaximum - this.descriptorTextSizeMinimum;
        return this.descriptorTextSizeMinimum + unit * range;
      },
    },
    {
      key: 'didSetInactiveColor',
      value: function didSetInactiveColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTextColor',
      value: function didSetTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryHeight',
      value: function didSetCategoryHeight(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryRadius',
      value: function didSetCategoryRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetRotationInDegrees',
      value: function didSetRotationInDegrees(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryRotationInDegrees',
      value: function didSetCategoryRotationInDegrees(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextIsArcAligned',
      value: function didSetCategoryTextIsArcAligned(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextColor',
      value: function didSetCategoryTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextFont',
      value: function didSetCategoryTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextSize',
      value: function didSetCategoryTextSize(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategoryTextSpacer',
      value: function didSetCategoryTextSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorHeightIsVariable',
      value: function didSetDescriptorHeightIsVariable(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorHeightAnchor',
      value: function didSetDescriptorHeightAnchor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorHeightFixed',
      value: function didSetDescriptorHeightFixed(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorHeightMaximum',
      value: function didSetDescriptorHeightMaximum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorHeightMinimum',
      value: function didSetDescriptorHeightMinimum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorRadiusInner',
      value: function didSetDescriptorRadiusInner(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorRadiusOuter',
      value: function didSetDescriptorRadiusOuter(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorRotationInDegrees',
      value: function didSetDescriptorRotationInDegrees(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorSpacerInDegrees',
      value: function didSetDescriptorSpacerInDegrees(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextIsArcAligned',
      value: function didSetDescriptorTextIsArcAligned(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextColor',
      value: function didSetDescriptorTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextFont',
      value: function didSetDescriptorTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextSizeMaximum',
      value: function didSetDescriptorTextSizeMaximum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextSizeMinimum',
      value: function didSetDescriptorTextSizeMinimum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorTextSpacer',
      value: function didSetDescriptorTextSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientIsVisible',
      value: function didSetGradientIsVisible(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientCurveWeight',
      value: function didSetGradientCurveWeight(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityIsVariable',
      value: function didSetGradientOpacityIsVariable(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityInner',
      value: function didSetGradientOpacityInner(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityOuter',
      value: function didSetGradientOpacityOuter(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetTotalDegrees',
      value: function didSetTotalDegrees(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Fruity',
      value: function didSetColor_Fruity(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Fruity', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Spicy',
      value: function didSetColor_Spicy(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Spicy', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Green',
      value: function didSetColor_Green(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Green', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Vegetable',
      value: function didSetColor_Vegetable(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Vegetable', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Herbal',
      value: function didSetColor_Herbal(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Herbal', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Floral',
      value: function didSetColor_Floral(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Floral', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Roasted',
      value: function didSetColor_Roasted(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Roasted', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Caramel',
      value: function didSetColor_Caramel(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Caramel', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Nutty',
      value: function didSetColor_Nutty(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Nutty', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Cheesy',
      value: function didSetColor_Cheesy(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Cheesy', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Woody',
      value: function didSetColor_Woody(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Woody', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Citrus',
      value: function didSetColor_Citrus(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Citrus', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Animal',
      value: function didSetColor_Animal(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Animal', newValue);

        this.stale = true;
      },
    },
    {
      key: 'didSetColor_Chemical',
      value: function didSetColor_Chemical(newValue) {
        _private$4(this).taxonomy.setCategoryColor('Chemical', newValue);

        this.stale = true;
      },
    },
    {
      key: 'render',
      value: function render(context) {
        /// Draw some stuff
        const _private4 = _private$4(this);
        const { ingredient } = _private4;

        const _private5 = _private$4(this);
        const { taxonomy } = _private5;

        const innerCategoryRadius = this.categoryRadius - this.categoryHeight / 2;
        const outerCategoryRadius = this.categoryRadius + this.categoryHeight / 2;
        const totalAngle = convertDegreesToRadians(this.totalDegrees);
        const totalCategoryAngle = totalAngle;
        const descriptorSpacerRadians = convertDegreesToRadians(this.descriptorSpacerInDegrees);
        const totalDescriptorAngle = totalAngle - ingredient.descriptorCount * descriptorSpacerRadians;
        const anglePerCategory = totalCategoryAngle / taxonomy.categoryCount;
        let startCategoryAngle = convertDegreesToRadians(defaultV2ViewValues.rotationInDegrees);
        let startDescriptorAngle =
          convertDegreesToRadians(defaultV2ViewValues.rotationInDegrees) + this.computeStartAngle();
        const isCategoryCentric = this.categoryRadius < this.descriptorRadiusInner;
        const isDescriptorCentric = this.categoryRadius > this.descriptorRadiusOuter; /// Draw the categories in taxonomy present in the ingredient

        for (let cindex = 0; cindex < taxonomy.categoryCount; cindex++) {
          const category = taxonomy.getCategoryByIndex(cindex);
          const isActiveCategory = ingredient.getCategoryByName(category.name); /// Category ring

          context.pushStyle({
            fillColor: isActiveCategory ? category.color : this.inactiveColor,
            strokeColor: null,
          });
          context.drawRingSector(
            this.width / 2,
            this.height / 2,
            innerCategoryRadius,
            outerCategoryRadius,
            startCategoryAngle,
            startCategoryAngle + anglePerCategory,
          );
          context.pushStyle(); /// Only draw descriptors for categories that are present

          if (isActiveCategory) {
            /// Draw the descriptors in the ingredient
            ingredient.getAromasForCategory(category);

            const _iterator2 = _createForOfIteratorHelper(ingredient.getAromasForCategory(category));
            var _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                var _taxonomy$getDescript;

                const aroma = _step2.value;
                const categoryWeight = ingredient.getTotalAromaValueForCategory(category) / ingredient.maxCategoryValue;
                const { descriptor } = aroma;
                const dMaxRadius = isCategoryCentric ? this.descriptorRadiusOuter : this.descriptorRadiusInner;
                const dMinRadius = isCategoryCentric ? this.descriptorRadiusInner : this.descriptorRadiusOuter;
                const descriptorRadius = dMinRadius + categoryWeight * (dMaxRadius - dMinRadius);
                const { maxAromaValue } = ingredient;
                const { minAromaValue } = ingredient;
                const normAromaValue =
                  minAromaValue != maxAromaValue
                    ? (aroma.value - minAromaValue) / (maxAromaValue - minAromaValue)
                    : aroma.value;
                const descriptorFixedHeight = defaultV2ViewValues.descriptorHeightFixed;
                const descriptorVariableHeight =
                  this.descriptorHeightMinimum +
                  normAromaValue * (this.descriptorHeightMaximum - this.descriptorHeightMinimum);
                const descriptorHeight = defaultV2ViewValues.descriptorHeightIsVariable
                  ? descriptorVariableHeight
                  : descriptorFixedHeight;
                let innerDescriptorRadius = null;
                let outerDescriptorRadius = null;
                const { descriptorHeightAnchor } = defaultV2ViewValues;

                if (descriptorHeightAnchor.toLowerCase() === 'inner') {
                  innerDescriptorRadius = descriptorRadius - descriptorHeight;
                  outerDescriptorRadius = descriptorRadius;
                } else if (descriptorHeightAnchor.toLowerCase() === 'outer') {
                  innerDescriptorRadius = descriptorRadius;
                  outerDescriptorRadius = descriptorRadius + descriptorHeight;
                } else {
                  /// center by default
                  innerDescriptorRadius = descriptorRadius - descriptorHeight / 2;
                  outerDescriptorRadius = descriptorRadius + descriptorHeight / 2;
                }

                const descriptorWeight = aroma.value / ingredient.totalAromaValue;
                const descriptorAngle = descriptorWeight * totalDescriptorAngle;
                const descriptor_color =
                  (_taxonomy$getDescript = taxonomy.getDescriptorByName(descriptor.name)) === null ||
                  _taxonomy$getDescript === void 0
                    ? void 0
                    : _taxonomy$getDescript.color; /// Descriptor ring

                context.pushStyle({
                  fillColor: descriptor_color,
                  strokeColor: null,
                });
                context.drawRingSector(
                  this.width / 2,
                  this.height / 2,
                  innerDescriptorRadius,
                  outerDescriptorRadius,
                  startDescriptorAngle,
                  startDescriptorAngle + descriptorAngle,
                );
                context.popStyle(); /// Descriptor bezier sector

                const originColor = {
                  red: 1.0,
                  green: 1.0,
                  blue: 1.0,
                  alpha: this.gradientOpacityInner,
                };
                const destinationColor = context.createRGBColor(descriptor_color); /// Radial gradient goes from view center towards inner radius

                const stops = [[originColor, 0.0]];
                let midpoint = null;

                if (isCategoryCentric) {
                  midpoint = Math.min(Math.max(outerCategoryRadius / innerDescriptorRadius, 0.0), 1.0);
                } else if (isDescriptorCentric) {
                  midpoint = Math.min(Math.max(outerDescriptorRadius / innerCategoryRadius, 0.0), 1.0);
                }

                if (midpoint) {
                  stops.push([originColor, midpoint]);
                }

                stops.push([destinationColor, 1.0]);
                const radius = Math.max(innerCategoryRadius, innerDescriptorRadius);
                const angle = startDescriptorAngle + descriptorAngle / 2;
                const gradientColor = {
                  gradient: {
                    stops,
                    radial: true,
                  },
                  origin: {
                    x: this.width / 2,
                    y: this.height / 2,
                  },
                  destination: {
                    x: radius * Math.cos(angle) + this.width / 2,
                    y: radius * Math.sin(angle) + this.height / 2,
                  },
                }; /// Draw the connections as Bezier sectors

                if (this.gradientIsVisible) {
                  if (defaultV2ViewValues.gradientOpacityIsVariable) {
                    destinationColor.alpha = normAromaValue * this.gradientOpacityOuter;
                  } else {
                    destinationColor.alpha = this.gradientOpacityOuter;
                  }

                  context.pushStyle({
                    fillColor: gradientColor,
                    strokeColor: null,
                  });
                  context.drawBezierSector(
                    this.width / 2,
                    this.height / 2,
                    isCategoryCentric ? outerCategoryRadius : innerCategoryRadius,
                    startCategoryAngle,
                    startCategoryAngle + anglePerCategory,
                    isCategoryCentric ? innerDescriptorRadius : outerDescriptorRadius,
                    startDescriptorAngle,
                    startDescriptorAngle + descriptorAngle,
                    defaultV2ViewValues.gradientCurveWeight,
                  );
                  context.popStyle();
                } /// Descriptor text

                const descriptorTextRadius = outerDescriptorRadius + this.descriptorTextSpacer;

                const _textAngle = startDescriptorAngle + descriptorAngle / 2;

                const _textX = descriptorTextRadius * Math.cos(_textAngle) + this.width / 2;

                const _textY = descriptorTextRadius * Math.sin(_textAngle) + this.height / 2;

                const _textAlignment = this.computeTextAlignment(_textAngle, this.descriptorTextIsArcAligned);

                const _textRotation = this.computeTextRotation(_textAngle, this.descriptorTextIsArcAligned);

                const descriptorTextSize = this.computeTextSize(normAromaValue);
                context.pushFont({
                  fontFamily: this.textFont,
                  fontSize: descriptorTextSize,
                  fontWeight: 'normal',
                });
                context.pushStyle({
                  fillColor: this.textColor,
                  strokeColor: null,
                });
                context.pushTypesetter({
                  textAlignmentX: _textAlignment.x,
                  textAlignmentY: _textAlignment.y,
                });

                const _textValue = descriptor.name.toLowerCase();

                context.drawText(_textValue, _textX, _textY, _textRotation);
                context.popTypesetter();
                context.popStyle();
                context.popFont(); /// Advance angle to next descriptor

                startDescriptorAngle += descriptorAngle + descriptorSpacerRadians;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } /// Category text

          const textAngle = startCategoryAngle + anglePerCategory / 2;
          const textRadius = this.categoryRadius + this.categoryTextSpacer;
          const textX = textRadius * Math.cos(textAngle) + this.width / 2;
          const textY = textRadius * Math.sin(textAngle) + this.height / 2;
          const textAlignment = this.computeTextAlignment(textAngle, this.categoryTextIsArcAligned);
          const textRotation = this.computeTextRotation(textAngle, this.categoryTextIsArcAligned);
          context.pushFont({
            fontFamily: this.textFont,
            fontSize: this.categoryTextSize,
            fontWeight: 'normal',
          });
          context.pushStyle({
            fillColor: isActiveCategory ? this.textColor : this.inactiveColor,
            strokeColor: null,
          });
          context.pushTypesetter({
            textAlignmentX: textAlignment.x,
            textAlignmentY: textAlignment.y,
          });
          const textValue = category.name.toLowerCase();
          context.drawText(textValue, textX, textY, textRotation);
          context.popTypesetter();
          context.popStyle();
          context.popFont(); /// Advance to the next category

          startCategoryAngle += anglePerCategory;
        }
      },
    },
    {
      key: 'update',
      value: function update(deltaTime) {},
    },
  ]);

  return IngredientViewV2;
})(
  object.defineProperties(
    AbstractView, /// Category parameters
    new object.ObservedProperty('textFont', defaultV2ViewValues.textFont),
    new object.ObservedProperty('textColor', defaultV2ViewValues.textColor),
    new object.ObservedProperty('inactiveColor', defaultV2ViewValues.inactiveColor),
    new object.ObservedProperty('rotationInDegrees', defaultV2ViewValues.rotationInDegrees),
    new object.ObservedProperty('categoryHeight', defaultV2ViewValues.categoryHeight),
    new object.ObservedProperty('categoryRadius', defaultV2ViewValues.categoryRadius),
    new object.ObservedProperty('categoryTextSize', defaultV2ViewValues.categoryTextSize),
    new object.ObservedProperty('categoryTextSpacer', defaultV2ViewValues.categoryTextSpacer), /// Descriptor parameters
    new object.ObservedProperty('descriptorHeightMaximum', defaultV2ViewValues.descriptorHeightMaximum),
    new object.ObservedProperty('descriptorHeightMinimum', defaultV2ViewValues.descriptorHeightMinimum),
    new object.ObservedProperty('descriptorRadiusInner', defaultV2ViewValues.descriptorRadiusInner),
    new object.ObservedProperty('descriptorRadiusOuter', defaultV2ViewValues.descriptorRadiusOuter),
    new object.ObservedProperty('descriptorSpacerInDegrees', defaultV2ViewValues.descriptorSpacerInDegrees),
    new object.ObservedProperty('descriptorTextSizeMaximum', defaultV2ViewValues.descriptorTextSizeMaximum),
    new object.ObservedProperty('descriptorTextSizeMinimum', defaultV2ViewValues.descriptorTextSizeMinimum),
    new object.ObservedProperty('descriptorTextSpacer', defaultV2ViewValues.descriptorTextSpacer), /// Gradient parameters
    new object.ObservedProperty('gradientIsVisible', defaultV2ViewValues.gradientIsVisible),
    new object.ObservedProperty('gradientOpacityInner', defaultV2ViewValues.gradientOpacityInner),
    new object.ObservedProperty('gradientOpacityOuter', defaultV2ViewValues.gradientOpacityOuter), /// Miscellaneous
    new object.ObservedProperty('totalDegrees', defaultV2ViewValues.totalDegrees), /// Category colors
    new object.ObservedProperty('color_Fruity', categoryColors.Fruity),
    new object.ObservedProperty('color_Spicy', categoryColors.Spicy),
    new object.ObservedProperty('color_Green', categoryColors.Green),
    new object.ObservedProperty('color_Vegetable', categoryColors.Vegetable),
    new object.ObservedProperty('color_Herbal', categoryColors.Herbal),
    new object.ObservedProperty('color_Floral', categoryColors.Floral),
    new object.ObservedProperty('color_Roasted', categoryColors.Roasted),
    new object.ObservedProperty('color_Caramel', categoryColors.Caramel),
    new object.ObservedProperty('color_Nutty', categoryColors.Nutty),
    new object.ObservedProperty('color_Cheesy', categoryColors.Cheesy),
    new object.ObservedProperty('color_Woody', categoryColors.Woody),
    new object.ObservedProperty('color_Citrus', categoryColors.Citrus),
    new object.ObservedProperty('color_Animal', categoryColors.Animal),
    new object.ObservedProperty('color_Chemical', categoryColors.Chemical),
  ),
);

/**
 * CustomIngredientViewV2
 */

const CustomIngredientViewV2 = /* #__PURE__ */ (function (_IngredientViewV) {
  _inherits(CustomIngredientViewV2, _IngredientViewV);

  const _super = _createSuper(CustomIngredientViewV2);

  function CustomIngredientViewV2() {
    _classCallCheck(this, CustomIngredientViewV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  _createClass(CustomIngredientViewV2, [
    {
      key: 'ingredientJSON',
      get: function get() {
        return JSON.stringify(this.ingredient, null, '  ');
      },
      set: function set(newValue) {
        this.updateIngredient(newValue);
        this.stale = true;
      },
    },
    {
      key: 'taxonomyJSON',
      get: function get() {
        return JSON.stringify(this.taxonomy, null, '  ');
      },
      set: function set(newValue) {
        this.updateTaxonomy(newValue);
        this.stale = true;
      },
    },
  ]);

  return CustomIngredientViewV2;
})(IngredientViewV2);

/**
 * TaxonomyView
 */

const _private$3 = namespace();

const TaxonomyView = /* #__PURE__ */ (function (_object$definePropert) {
  _inherits(TaxonomyView, _object$definePropert);

  const _super = _createSuper(TaxonomyView);

  function TaxonomyView() {
    let _this;

    _classCallCheck(this, TaxonomyView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    const _args = _construct(object.Arguments, args);

    _private$3(_assertThisInitialized(_this)).ingredient = _args.get('ingredient');
    _private$3(_assertThisInitialized(_this)).taxonomy = _args.get('taxonomy');
    return _this;
  }

  _createClass(TaxonomyView, [
    {
      key: 'didSetCategoryRadius',
      value: function didSetCategoryRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetCategorySpacer',
      value: function didSetCategorySpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorRadius',
      value: function didSetDescriptorRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorSpacer',
      value: function didSetDescriptorSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDrawStroke',
      value: function didSetDrawStroke(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetInnerRadius',
      value: function didSetInnerRadius(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'render',
      value: function render(context) {
        const _private2 = _private$3(this);
        const { taxonomy } = _private2;

        const { categoryCount } = taxonomy;
        const { descriptorCount } = taxonomy;
        const totalCategorySpacer = categoryCount * this.categorySpacer;
        const totalDescriptorSpacer = (descriptorCount - categoryCount) * this.descriptorSpacer;
        let startAngle = 0;
        const totalAngle = 2 * Math.PI - totalCategorySpacer - totalDescriptorSpacer;
        const anglePerDescriptor = totalAngle / descriptorCount;
        const { drawStroke } = this;

        for (let cindex = 0; cindex < taxonomy.categoryCount; cindex++) {
          const category = taxonomy.getCategoryByIndex(cindex);
          const descriptors = taxonomy.getDescriptorsForCategory(category);
          const startCategoryAngle = startAngle;

          const _iterator = _createForOfIteratorHelper(descriptors);
          var _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
              const descriptor = _step.value;
              context.pushStyle({
                fillColor: descriptor.color,
                strokeColor: drawStroke ? descriptor.color : null,
              });
              context.drawRingSector(
                this.width / 2,
                this.height / 2,
                this.innerRadius,
                this.categoryRadius,
                startAngle,
                startAngle + anglePerDescriptor,
              );
              context.popStyle();

              const _midRadius = 1.04 * this.categoryRadius;

              const _textAngle = startAngle + anglePerDescriptor / 2;

              const _textX = _midRadius * Math.cos(_textAngle) + this.width / 2;

              const _textY = _midRadius * Math.sin(_textAngle) + this.height / 2;

              let _textRotation = 0;
              let textAlignmentX = 'left';

              if (Math.PI / 2 < _textAngle && _textAngle < (3 * Math.PI) / 2) {
                textAlignmentX = 'right';
                _textRotation = Math.atan2(Math.sin(_textAngle), Math.cos(_textAngle)) - Math.PI;
              } else {
                textAlignmentX = 'left';
                _textRotation = Math.atan2(Math.sin(_textAngle), Math.cos(_textAngle));
              }

              context.pushFont({
                fontFamily: 'Helvetica Neue',
                fontSize: 12,
                fontWeight: 'normal',
              });
              context.pushStyle({
                fillColor: '#808080',
                strokeColor: null,
              });
              context.pushTypesetter({
                textAlignmentX,
                textAlignmentY: 'center',
              });
              context.drawText(descriptor.name.toLowerCase(), _textX, _textY, _textRotation);
              context.popTypesetter();
              context.popStyle();
              context.popFont(); /// Advance angle to next descriptor

              startAngle += anglePerDescriptor + this.descriptorSpacer;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          const stopCategoryAngle = startAngle;
          const midRadius = (this.categoryRadius + this.descriptorRadius) / 2;
          context.pushStyle({
            fillColor: category.color,
            strokeColor: drawStroke ? category.color : null,
          });
          context.drawRingSector(
            this.width / 2,
            this.height / 2,
            midRadius - 2,
            midRadius + 2,
            startCategoryAngle,
            stopCategoryAngle,
          );
          context.popStyle();
          const textAngle = (startCategoryAngle + stopCategoryAngle) / 2;
          const textX = 1.05 * midRadius * Math.cos(textAngle) + this.width / 2;
          const textY = 1.05 * midRadius * Math.sin(textAngle) + this.height / 2;
          let textRotation = 0;

          if (textAngle > 0 && textAngle < Math.PI) {
            textRotation = Math.atan2(Math.sin(textAngle), Math.cos(textAngle)) - Math.PI / 2;
          } else {
            textRotation = Math.atan2(Math.sin(textAngle), Math.cos(textAngle)) + Math.PI / 2;
          }

          context.pushFont({
            fontFamily: 'Helvetica Neue',
            fontSize: 12,
            fontWeight: 'bold',
          });
          context.pushStyle({
            fillColor: category.color,
            strokeColor: null,
          });
          context.pushTypesetter({
            textAlignmentX: 'center',
          });
          context.drawText(category.name.toLowerCase(), textX, textY, textRotation);
          context.popTypesetter();
          context.popStyle();
          context.popFont(); /// Advance angle to next category

          startAngle += this.categorySpacer - this.descriptorSpacer;
        }
      },
    },
    {
      key: 'update',
      value: function update(deltaTime) {},
    },
    {
      key: 'updateTaxonomy',
      value: function updateTaxonomy(taxonomy) {
        _private$3(this).taxonomy = taxonomy;
        this.stale = true;
      },
    },
    {
      key: 'taxonomy',
      get: function get() {
        return _private$3(this).taxonomy;
      },
    },
  ]);

  return TaxonomyView;
})(
  object.defineProperties(
    AbstractView,
    new object.ObservedProperty('categoryRadius', 240),
    new object.ObservedProperty('categorySpacer', 0.04),
    new object.ObservedProperty('descriptorRadius', 420),
    new object.ObservedProperty('descriptorSpacer', 0.004),
    new object.ObservedProperty('drawStroke', false),
    new object.ObservedProperty('innerRadius', 160),
  ),
);

/**
 * CustomTaxonomyView
 */

const CustomTaxonomyView = /* #__PURE__ */ (function (_TaxonomyView) {
  _inherits(CustomTaxonomyView, _TaxonomyView);

  const _super = _createSuper(CustomTaxonomyView);

  function CustomTaxonomyView() {
    _classCallCheck(this, CustomTaxonomyView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  _createClass(CustomTaxonomyView, [
    {
      key: 'taxonomyJSON',
      get: function get() {
        return JSON.stringify(this.taxonomy, null, '  ');
      },
      set: function set(newValue) {
        this.updateTaxonomy(newValue);
        this.stale = true;
      },
    },
  ]);

  return CustomTaxonomyView;
})(TaxonomyView);

/**
 * LinearIngredientView
 */

const _private$2 = namespace();

const LinearIngredientView = /* #__PURE__ */ (function (_object$definePropert) {
  _inherits(LinearIngredientView, _object$definePropert);

  const _super = _createSuper(LinearIngredientView);

  function LinearIngredientView() {
    let _this;

    _classCallCheck(this, LinearIngredientView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    const _args = _construct(object.Arguments, args);

    const ingredient = _args.get('ingredient');

    _private$2(_assertThisInitialized(_this)).ingredients = [ingredient, ingredient, ingredient];
    _private$2(_assertThisInitialized(_this)).ingredient = ingredient;
    _private$2(_assertThisInitialized(_this)).taxonomy = _args.get('taxonomy');
    return _this;
  }

  _createClass(LinearIngredientView, [
    {
      key: 'didSetSpaceBeforeLegend',
      value: function didSetSpaceBeforeLegend(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetSpaceWithinLegend',
      value: function didSetSpaceWithinLegend(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetSpaceBeforeFirstIngredient',
      value: function didSetSpaceBeforeFirstIngredient(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetSpaceBetweenIngredients',
      value: function didSetSpaceBetweenIngredients(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetInactiveColor',
      value: function didSetInactiveColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetUniqueDescriptors',
      value: function didSetUniqueDescriptors(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientCurveWeight',
      value: function didSetGradientCurveWeight(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityIsVariable',
      value: function didSetGradientOpacityIsVariable(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityFixedLeft',
      value: function didSetGradientOpacityFixedLeft(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityFixedRight',
      value: function didSetGradientOpacityFixedRight(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityMaximum',
      value: function didSetGradientOpacityMaximum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetGradientOpacityMinimum',
      value: function didSetGradientOpacityMinimum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorSpacer',
      value: function didSetDescriptorSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorWidthIsVariable',
      value: function didSetDescriptorWidthIsVariable(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorWidthAnchor',
      value: function didSetDescriptorWidthAnchor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorWidthFixed',
      value: function didSetDescriptorWidthFixed(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorWidthMinimum',
      value: function didSetDescriptorWidthMinimum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetDescriptorWidthMaximum',
      value: function didSetDescriptorWidthMaximum(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetIngredientNameTextColor',
      value: function didSetIngredientNameTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetIngredientNameTextFont',
      value: function didSetIngredientNameTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetIngredientNameTextSize',
      value: function didSetIngredientNameTextSize(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetIngredientNameTextSpacer',
      value: function didSetIngredientNameTextSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategorySpacer',
      value: function didSetLegendCategorySpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategoryWidth',
      value: function didSetLegendCategoryWidth(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategoryTextColor',
      value: function didSetLegendCategoryTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategoryTextFont',
      value: function didSetLegendCategoryTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategoryTextSize',
      value: function didSetLegendCategoryTextSize(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendCategoryTextSpacer',
      value: function didSetLegendCategoryTextSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorSpacer',
      value: function didSetLegendDescriptorSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorWidth',
      value: function didSetLegendDescriptorWidth(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorTextColor',
      value: function didSetLegendDescriptorTextColor(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorTextFont',
      value: function didSetLegendDescriptorTextFont(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorTextSize',
      value: function didSetLegendDescriptorTextSize(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'didSetLegendDescriptorTextSpacer',
      value: function didSetLegendDescriptorTextSpacer(newValue) {
        this.stale = true;
      },
    },
    {
      key: 'render',
      value: function render(context) {
        const _private2 = _private$2(this);
        const { ingredients } = _private2;

        const _private3 = _private$2(this);
        const { taxonomy } = _private3;

        const marginX = this.spaceBeforeLegend;
        const marginBottom = 20;
        const marginTop = 36;
        const totalHeight = this.height - marginBottom - marginTop;
        const totalCategoryHeight = totalHeight - (taxonomy.categoryCount - 1) * this.legendCategorySpacer;
        const categoryX = marginX;
        let categoryY = this.height - marginBottom;
        const aromaYs = [];

        while (aromaYs.length < ingredients.length) {
          aromaYs.push(categoryY);
        } /// Collect the present/unique x categories/descriptors

        const activeDescriptorList = {};
        const uniqueDescriptorList = {};
        const activeCategoryList = {};
        const categoryToDescriptors = {};

        const _iterator = _createForOfIteratorHelper(ingredients);
        let _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            const _ingredient = _step.value;

            for (let aindex = 0; aindex < _ingredient.aromaCount; aindex++) {
              const _aroma = _ingredient.getAromaByIndex(aindex);

              const _descriptor = _aroma.descriptor;
              const _category = _descriptor.category;

              if (!categoryToDescriptors[_category.name]) {
                categoryToDescriptors[_category.name] = {};
              }

              categoryToDescriptors[_category.name][_descriptor.name] = true;

              if (activeDescriptorList[_descriptor.name]) {
                activeDescriptorList[_descriptor.name] += 1;
                uniqueDescriptorList[_descriptor.name] = false;
              } else {
                activeDescriptorList[_descriptor.name] = 1;
                uniqueDescriptorList[_descriptor.name] = true;
              }

              if (activeCategoryList[_category.name]) {
                activeCategoryList[_category.name] += 1;
              } else {
                activeCategoryList[_category.name] = 1;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        const uniqueCategoryList = {};

        for (let _i = 0, _Object$keys = Object.keys(categoryToDescriptors); _i < _Object$keys.length; _i++) {
          const cname = _Object$keys[_i];
          let active = false;

          for (
            let _i2 = 0, _Object$keys2 = Object.keys(categoryToDescriptors[cname]);
            _i2 < _Object$keys2.length;
            _i2++
          ) {
            const dname = _Object$keys2[_i2];
            active |= uniqueDescriptorList[dname];
          }

          uniqueCategoryList[cname] = active;
        } /// Draw the categories in the taxonomy

        let shouldDrawIngredientNames = ingredients.length;

        for (let cindex = 0; cindex < taxonomy.categoryCount; cindex++) {
          const category = taxonomy.getCategoryByIndex(cindex);
          const descriptors = taxonomy.getDescriptorsForCategory(category);
          const categoryHeight = totalCategoryHeight * (descriptors.length / taxonomy.descriptorCount);
          const descriptorX = categoryX + this.spaceWithinLegend + this.legendCategoryWidth;
          let descriptorY = categoryY;
          const totalDescriptorHeight = categoryHeight - (descriptors.length - 1) * this.legendDescriptorSpacer;
          const descriptorHeight = totalDescriptorHeight / descriptors.length;
          const isActiveCategory = this.uniqueDescriptors
            ? uniqueCategoryList[category.name]
            : activeCategoryList[category.name]; /// Draw the descriptors in taxonomy

          const _iterator2 = _createForOfIteratorHelper(descriptors);
          var _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
              const descriptor = _step2.value;
              let isActiveDescriptor = true;

              if (this.uniqueDescriptors) {
                isActiveDescriptor = uniqueDescriptorList[descriptor.name];
              } else {
                isActiveDescriptor = activeDescriptorList[descriptor.name];
              }

              descriptorY -= descriptorHeight;
              context.pushStyle({
                fillColor: isActiveDescriptor ? descriptor.color : this.inactiveColor,
                strokeColor: null,
              });
              context.drawRectangle(descriptorX, descriptorY, this.legendDescriptorWidth, descriptorHeight);
              context.popStyle(); /// Draw the descriptor labels

              context.pushFont({
                fontFamily: this.legendDescriptorTextFont,
                fontSize: this.legendDescriptorTextSize,
                fontWeight: 'normal',
              });
              context.pushStyle({
                fillColor: isActiveDescriptor ? this.legendDescriptorTextColor : this.inactiveColor,
                strokeColor: null,
              });
              context.pushTypesetter({
                textAlignmentX: 'right',
                textAlignmentY: 'center',
              });
              context.drawText(
                descriptor.name.toLowerCase(),
                descriptorX - this.legendDescriptorTextSpacer,
                descriptorY + descriptorHeight / 2,
              );
              context.popTypesetter();
              context.popStyle();
              context.popFont(); /// Draw the ingredient aroma descriptors

              const previousIngredient = [];

              while (previousIngredient.length < ingredients.length + 1) {
                previousIngredient.push({});
              }

              previousIngredient[0][descriptor.name] = {};
              previousIngredient[0][descriptor.name].x = descriptorX + this.legendDescriptorWidth;
              previousIngredient[0][descriptor.name].y3 = descriptorY;
              previousIngredient[0][descriptor.name].y4 = descriptorY + descriptorHeight;

              if (this.gradientOpacityIsVariable) {
                previousIngredient[0][descriptor.name].normAromaValue = this.gradientOpacityMinimum;
              } else {
                previousIngredient[0][descriptor.name].normAromaValue = this.gradientOpacityFixedLeft;
              }

              for (let i = 0; i < ingredients.length; i++) {
                const ingredient = ingredients[i];
                const aroma = ingredient.getAromaByDescriptorName(descriptor.name);
                const aromaValue = aroma ? aroma.value : 0.0;
                const { maxAromaValue } = ingredient;
                const { minAromaValue } = ingredient;
                const normAromaValue = (aromaValue - minAromaValue) / (maxAromaValue - minAromaValue);
                let descriptorWidth = this.descriptorWidthFixed;
                let descriptorOffsetX = 0.0;

                if (this.descriptorWidthIsVariable) {
                  const descriptorWidthRange = this.descriptorWidthMaximum - this.descriptorWidthMinimum;
                  descriptorWidth = this.descriptorWidthMinimum + normAromaValue * descriptorWidthRange;

                  if (this.descriptorWidthAnchor === 'left') {
                    descriptorOffsetX = 0.0;
                  } else if (this.descriptorWidthAnchor === 'right') {
                    descriptorOffsetX = -descriptorWidth;
                  } else {
                    /// assume 'center' is default anchor
                    descriptorOffsetX = -descriptorWidth / 2;
                  }
                }

                let ingredientX = descriptorX + descriptorWidth / 2 + descriptorOffsetX;
                ingredientX += this.spaceBeforeFirstIngredient + i * this.spaceBetweenIngredients; /// Draw the ingredient names (once!)

                if (shouldDrawIngredientNames > 0) {
                  context.pushFont({
                    fontFamily: this.ingredientNameTextFont,
                    fontSize: this.ingredientNameTextSize,
                    fontWeight: 'normal',
                  });
                  context.pushStyle({
                    fillColor: this.ingredientNameTextColor,
                    strokeColor: null,
                  });
                  context.pushTypesetter({
                    textAlignmentX: 'center',
                    textAlignmentY: 'baseline',
                  });
                  context.drawText(
                    ingredient.name.toLowerCase(),
                    ingredientX,
                    marginTop - this.ingredientNameTextSpacer,
                  );
                  context.popTypesetter();
                  context.popStyle();
                  context.popFont();
                  shouldDrawIngredientNames--;
                }

                previousIngredient[i + 1][descriptor.name] = {};
                previousIngredient[i + 1][descriptor.name].x = ingredientX + descriptorWidth / 2;
                previousIngredient[i + 1][descriptor.name].y3 = aromaYs[i];
                previousIngredient[i + 1][descriptor.name].y4 = aromaYs[i]; /// Draw the ingredient aroma descriptors

                const totalAromaHeight = totalHeight - (ingredient.aromaCount - 1) * this.descriptorSpacer;
                const unitValue = aromaValue / ingredient.totalAromaValue;
                const aromaX = ingredientX - descriptorWidth / 2;
                let aromaY = aromaYs[i];
                const aromaWidth = descriptorWidth;
                const aromaHeight = unitValue * totalAromaHeight; /// Draw aroma bars

                if (aroma) {
                  aromaYs[i] -= aromaHeight;
                  aromaY = aromaYs[i];
                  const descriptorColor = isActiveDescriptor ? descriptor.color : this.inactiveColor; // if (this.uniqueDescriptors) {
                  // descriptorColor = (uniqueDescriptorList[descriptor.name]) ? descriptor.color : this.uniqueDescriptorColor;
                  // }

                  context.pushStyle({
                    fillColor: descriptorColor,
                    strokeColor: null,
                  });
                  context.drawRectangle(aromaX, aromaYs[i], aromaWidth, aromaHeight);
                  context.popStyle();
                  aromaYs[i] -= this.descriptorSpacer;
                } /// Draw the ingredient aroma gradients

                const baseColor = isActiveDescriptor ? descriptor.color : this.inactiveColor;
                const originColor = context.createRGBColor(baseColor);
                const destinationColor = context.createRGBColor(baseColor);
                let originX = marginX + this.legendCategoryWidth + this.legendDescriptorWidth + this.spaceWithinLegend;
                let destinationX = originX + this.spaceBeforeFirstIngredient;
                destinationX += (ingredients.length - 1) * (this.spaceBetweenIngredients + descriptorWidth);

                if (this.gradientOpacityIsVariable) {
                  originX = previousIngredient[i][descriptor.name].x;
                  destinationX = aromaX;
                  originColor.alpha = Tween.lerpNumber(
                    this.gradientOpacityMinimum,
                    this.gradientOpacityMaximum,
                    previousIngredient[i][descriptor.name].normAromaValue,
                  );
                  destinationColor.alpha = Tween.lerpNumber(
                    this.gradientOpacityMinimum,
                    this.gradientOpacityMaximum,
                    normAromaValue,
                  );
                } else {
                  originColor.alpha = this.gradientOpacityFixedLeft;
                  destinationColor.alpha = this.gradientOpacityFixedRight;
                }

                const gradientColor = {
                  gradient: {
                    stops: [
                      [originColor, 0.0],
                      [destinationColor, 1.0],
                    ],
                    radial: false,
                  },
                  origin: {
                    x: originX,
                    y: 0.0,
                  },
                  destination: {
                    x: destinationX,
                    y: 0.0,
                  },
                };
                context.pushStyle({
                  fillColor: gradientColor,
                  strokeColor: null,
                });
                const x1 = aromaX;
                const y1 = aroma ? aromaY + aromaHeight : aromaY + this.descriptorSpacer / 2;
                const x2 = x1;
                const y2 = aroma ? aromaY : y1;
                const x3 = previousIngredient[i][descriptor.name].x;
                const { y3 } = previousIngredient[i][descriptor.name];
                const x4 = x3;
                const { y4 } = previousIngredient[i][descriptor.name];
                const epsilon = 0.001;
                const visible = Math.abs(y1 - y2) > epsilon || Math.abs(y3 - y4) > epsilon;

                if (visible) {
                  context.drawBezierBand(x1, y1, x2, y2, x3, y3, x4, y4, 1.0 - this.gradientCurveWeight);
                }

                context.popStyle();
                previousIngredient[i + 1][descriptor.name].y3 = y2;
                previousIngredient[i + 1][descriptor.name].y4 = y1;
                previousIngredient[i + 1][descriptor.name].normAromaValue = normAromaValue;
              }

              descriptorY -= this.legendDescriptorSpacer;
            } /// Draw the categories in taxonomy
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          categoryY -= categoryHeight;
          context.pushStyle({
            fillColor: isActiveCategory ? category.color : this.inactiveColor,
            strokeColor: null,
          });
          context.drawRectangle(categoryX, categoryY, this.legendCategoryWidth, categoryHeight);
          context.popStyle(); /// Draw the category labels

          context.pushFont({
            fontFamily: this.legendCategoryTextFont,
            fontSize: this.legendCategoryTextSize,
            fontWeight: 'normal',
          });
          context.pushStyle({
            fillColor: isActiveCategory ? this.legendCategoryTextColor : this.inactiveColor,
            strokeColor: null,
          });
          context.pushTypesetter({
            textAlignmentX: 'right',
            textAlignmentY: 'center',
          });
          const textX = categoryX - this.legendCategoryTextSpacer;
          const textY = categoryY + categoryHeight / 2;
          const textValue = category.name.toLowerCase();
          context.drawText(textValue, textX, textY);
          context.popTypesetter();
          context.popStyle();
          context.popFont();
          categoryY -= this.legendCategorySpacer;
        }
      },
    },
    {
      key: 'update',
      value: function update(deltaTime) {},
    },
    {
      key: 'updateIngredient',
      value: function updateIngredient(ingredient, index) {
        _private$2(this).ingredients[index] = ingredient;
        this.stale = true;
      },
    },
    {
      key: 'updateTaxonomy',
      value: function updateTaxonomy(taxonomy) {
        _private$2(this).taxonomy = taxonomy;
        this.stale = true;
      },
    },
  ]);

  return LinearIngredientView;
})(
  object.defineProperties(
    AbstractView, /// Layout parameters
    new object.ObservedProperty('spaceBeforeLegend', 500),
    new object.ObservedProperty('spaceWithinLegend', 70),
    new object.ObservedProperty('spaceBeforeFirstIngredient', 200),
    new object.ObservedProperty('spaceBetweenIngredients', 400), /// Modal parameters
    new object.ObservedProperty('inactiveColor', '#eeefee'),
    new object.ObservedProperty('uniqueDescriptors', false), /// Ingredient parameters
    new object.ObservedProperty('ingredientNameTextColor', '#666766'),
    new object.ObservedProperty('ingredientNameTextFont', 'Helvetica Neue Medium'),
    new object.ObservedProperty('ingredientNameTextSize', 14),
    new object.ObservedProperty('ingredientNameTextSpacer', 10), /// Gradient parameters
    new object.ObservedProperty('gradientCurveWeight', 0.45),
    new object.ObservedProperty('gradientOpacityIsVariable', false),
    new object.ObservedProperty('gradientOpacityFixedLeft', 0.9),
    new object.ObservedProperty('gradientOpacityFixedRight', 0.1),
    new object.ObservedProperty('gradientOpacityMaximum', 0.9),
    new object.ObservedProperty('gradientOpacityMinimum', 0.1), /// Ingredient parameters
    new object.ObservedProperty('descriptorSpacer', 6),
    new object.ObservedProperty('descriptorWidthIsVariable', false),
    new object.ObservedProperty('descriptorWidthAnchor', 'center'),
    new object.ObservedProperty('descriptorWidthFixed', 9),
    new object.ObservedProperty('descriptorWidthMaximum', 18),
    new object.ObservedProperty('descriptorWidthMinimum', 4), /// Legend parameters
    new object.ObservedProperty('legendCategorySpacer', 4),
    new object.ObservedProperty('legendCategoryWidth', 12),
    new object.ObservedProperty('legendCategoryTextColor', '#666766'),
    new object.ObservedProperty('legendCategoryTextFont', 'Helvetica Neue Medium'),
    new object.ObservedProperty('legendCategoryTextSize', 12),
    new object.ObservedProperty('legendCategoryTextSpacer', 6),
    new object.ObservedProperty('legendDescriptorSpacer', 3),
    new object.ObservedProperty('legendDescriptorWidth', 9),
    new object.ObservedProperty('legendDescriptorTextColor', '#666766'),
    new object.ObservedProperty('legendDescriptorTextFont', 'Helvetica Neue Medium'),
    new object.ObservedProperty('legendDescriptorTextSize', 10),
    new object.ObservedProperty('legendDescriptorTextSpacer', 4),
  ),
);

/**
 * ParameterView
 */

const _private$1 = namespace();

const compare = function compare(a1, a2) {
  if (a1.length !== a2.length) {
    return false;
  }

  for (let i = 0; i < a1.length; i++) {
    if (a1[i] !== a2[i]) {
      return false;
    }
  }

  return true;
};

const ParameterView = /* #__PURE__ */ (function () {
  function ParameterView(name, parent, x, y) {
    _classCallCheck(this, ParameterView);

    _private$1(this).settings = QuickSettings__default.default.create(x, y, name, parent);

    _private$1(this).settings.setDraggable(false);
  }

  _createClass(ParameterView, [
    {
      key: 'addButton',
      value: function addButton(name, callback) {
        _private$1(this).settings.addButton(name, callback);
      },
    },
    {
      key: 'addCheckbox',
      value: function addCheckbox(name, value, callback) {
        _private$1(this).settings.addBoolean(name, value, callback);
      },
    },
    {
      key: 'addColor',
      value: function addColor(name, value, callback) {
        _private$1(this).settings.addColor(name, value, callback);
      },
    },
    {
      key: 'addObject',
      value: function addObject(object) {
        const _this = this;

        const root = Object.keys(Object.getOwnPropertyDescriptors(Object.getPrototypeOf({})));
        let proto = Object.getPrototypeOf(object);
        let descriptors = Object.getOwnPropertyDescriptors(proto);
        let current = Object.keys(descriptors); /// Loop through and expose get:set parameters for tweaking

        const completed = {};

        while (compare(current, root) === false) {
          const _loop = function _loop() {
            const key = _Object$keys[_i];

            if (!completed[key] && descriptors[key].get && descriptors[key].set) {
              const value = object[key];

              if (typeof value === 'number') {
                _this.addText(key, value, (newValue) => {
                  object[key] = Number(newValue);
                });
              } else if (typeof value === 'string') {
                _this.addText(key, value, (newValue) => {
                  object[key] = String(newValue);
                });
              } else if (typeof value === 'boolean') {
                _this.addCheckbox(key, value, (newValue) => {
                  object[key] = Boolean(newValue);
                });
              } else {
                console.warn('Unsupported parameter:', _typeof(value), key, value);
              }

              completed[key] = true;
            }
          };

          for (var _i = 0, _Object$keys = Object.keys(descriptors); _i < _Object$keys.length; _i++) {
            _loop();
          } /// Advance to next prototype

          proto = Object.getPrototypeOf(proto);
          descriptors = Object.getOwnPropertyDescriptors(proto);
          current = Object.keys(descriptors);
        }
      },
    },
    {
      key: 'addOptions',
      value: function addOptions(name, options, index, callback) {
        _private$1(this).settings.addDropDown(name, options, callback);

        _private$1(this).settings.setValue(name, index);
      },
    },
    {
      key: 'addRange',
      value: function addRange(name, min, max, value, step, callback) {
        _private$1(this).settings.addRange(name, min, max, value, step, callback);
      },
    },
    {
      key: 'addText',
      value: function addText(name, value, callback) {
        if (value.length > 80) {
          _private$1(this).settings.addTextArea(name, value, callback);
        } else {
          _private$1(this).settings.addText(name, value, callback);
        }
      },
    },
    {
      key: 'remove',
      value: function remove() {
        _private$1(this).settings.destroy();
      },
    },
    {
      key: 'setHeight',
      value: function setHeight(newValue) {
        _private$1(this).settings.setHeight(newValue);
      },
    },
    {
      key: 'setWidth',
      value: function setWidth(newValue) {
        _private$1(this).settings.setWidth(newValue);
      },
    },
  ]);

  return ParameterView;
})();

/**
 * TaxonomyViewV2
 */

const _private = namespace();

const TaxonomyViewV2 = /* #__PURE__ */ (function (_object$definePropert) {
  _inherits(TaxonomyViewV2, _object$definePropert);

  const _super = _createSuper(TaxonomyViewV2);

  function TaxonomyViewV2() {
    let _this;

    _classCallCheck(this, TaxonomyViewV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    const _args = _construct(object.Arguments, args);

    _private(_assertThisInitialized(_this)).ingredient = _args.get('ingredient');
    _private(_assertThisInitialized(_this)).taxonomy = _args.get('taxonomy');
    _this.categoryHeight = 6;
    _this.descriptorHeightMaximum = 12;
    _this.descriptorRadiusInner = 160;
    _this.descriptorRadiusOuter = 520;
    _this.descriptorSpacerInDegrees = 0.5;
    _this.gradientOpacityInner = 0.05;
    _this.gradientOpacityOuter = 1;
    return _this;
  }

  return _createClass(TaxonomyViewV2);
})(object.defineProperties(IngredientViewV2));

let _a;
let ViewType;

(function (ViewType) {
  ViewType.IngredientViewV1 = 'IngredientViewV1';
  ViewType.IngredientViewV2 = 'IngredientViewV2';
  ViewType.LinearIngredientView = 'LinearIngredientView';
  ViewType.CustomIngredientViewV1 = 'CustomIngredientViewV1';
  ViewType.CustomIngredientViewV2 = 'CustomIngredientViewV2';
  ViewType.TaxonomyView = 'TaxonomyView';
  ViewType.TaxonomyViewV2 = 'TaxonomyViewV2';
  ViewType.CustomTaxonomyView = 'CustomTaxonomyView';
})(ViewType || (ViewType = {}));

const ViewMapping =
  ((_a = {}),
  (_a[ViewType.IngredientViewV1] = IngredientViewV1),
  (_a[ViewType.IngredientViewV2] = IngredientViewV2),
  (_a[ViewType.LinearIngredientView] = LinearIngredientView),
  (_a[ViewType.CustomIngredientViewV1] = CustomIngredientViewV1),
  (_a[ViewType.CustomIngredientViewV2] = CustomIngredientViewV2),
  (_a[ViewType.TaxonomyView] = TaxonomyView),
  (_a[ViewType.TaxonomyViewV2] = TaxonomyViewV2),
  (_a[ViewType.CustomTaxonomyView] = CustomTaxonomyView),
  _a);
const views = {
  CustomIngredientViewV1,
  CustomIngredientViewV2,
  CustomTaxonomyView,
  IngredientViewV1,
  IngredientViewV2,
  LinearIngredientView,
  ParameterView,
  TaxonomyView,
  TaxonomyViewV2,
};

function downloadSvg(el, fileName) {
  if (fileName === void 0) {
    fileName = 'file.svg';
  }

  if (el) {
    let content = el.toString();

    if (el instanceof SVGSVGElement) {
      el.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      content = el === null || el === void 0 ? void 0 : el.outerHTML;
    }

    const preface = `<?xml version='1.0' standalone='no'?>\r\n`;
    const svgBlob = new Blob([preface, content], {
      type: 'image/svg+xml;charset=utf-8',
    });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}

const patchCategoryColor = function patchCategoryColor(name) {
  const categories = categoryColors;
  return categories[name];
}; /// FIXME: Patches for category index

const patchIngredientJSON = function patchIngredientJSON(response) {
  for (let i = 0; i < response.aromas.length; i++) {
    /// Category patches
    const cname = response.aromas[i]._links.descriptor._links.type.name; // let cdesc = response.aromas[i]._links.descriptor._links.type.description;

    const ccolor = response.aromas[i]._links.descriptor._links.type._meta.color; // let cindex = response.aromas[i]._links.descriptor._links.type._meta.index;
    // response.aromas[i]._links.descriptor._links.type.description = cdesc || '';

    response.aromas[i]._links.descriptor._links.type._meta.color = ccolor || patchCategoryColor(cname); // response.aromas[i]._links.descriptor._links.type._meta.index = cindex || patchCategoryIndex(cname);
    /// Descriptor patches

    response.aromas[i]._links.descriptor.name; // let ddesc = response.aromas[i]._links.descriptor.description;

    const dcolor = response.aromas[i]._links.descriptor._meta.color; // let dindex = response.aromas[i]._links.descriptor._meta.index;
    // response.aromas[i]._links.descriptor.description = ddesc || '';

    response.aromas[i]._links.descriptor._meta.color = dcolor || patchCategoryColor(cname); // response.aromas[i]._links.descriptor._meta.index = dindex || patchDescriptorIndex(dname);
  } /// Intensity patch

  response.intensity = 1.0;
  return response;
}; /// FIXME: Patches for taxonomy

const patchTaxonomyJSON = function patchTaxonomyJSON(response) {
  for (let i = 0; i < response.length; i++) {
    /// Category patches
    const cname = response[i]._links.type.name; // let cdesc = response[i]._links.type.description;

    const ccolor = response[i]._links.type._meta.color; // let cindex = response[i]._links.type._meta.index;
    // response[i]._links.type.description = cdesc || '';

    response[i]._links.type._meta.color = ccolor || patchCategoryColor(cname); // response[i]._links.type._meta.index = cindex || patchCategoryIndex(cname);
    /// Descriptor patches
    // let dname = response[i].name;
    // let ddesc = response[i].description;

    const dcolor = response[i]._meta.color; // let dindex = response[i]._meta.index;
    // response[i].description = ddesc || '';

    response[i]._meta.color = dcolor || patchCategoryColor(cname); // response[i]._meta.index = dindex || patchDescriptorIndex(dname);
  } /// unset Odorless and Not found
  /// FIXME: next line removes 2 items each time when it is applied
  /// response.splice(response.length - 2, 2);

  return response;
};

const index$1 = /* #__PURE__ */ Object.freeze({
  __proto__: null,
  downloadSvg,
  Renderer: renderer,
  ViewMapping,
  get ViewType() {
    return ViewType;
  },
  patchIngredientJSON,
  patchTaxonomyJSON,
  models,
});

const CELL_WIDTH = AromaDotStateSizeMapping[AromaDotState.ExistsShared];
const INITIAL_ROW_OFFSET_X = 300;
const INITIAL_ROW_OFFSET_Y = 50;
function convertRowToIngredient(row, sharedAromaTypes) {
  const { id } = row;
  const { name } = row;
  const { aromaTypes } = row;
  const ingredientOutput = {
    id,
    name,
  };
  AromaTypesArray.forEach((aroma) => {
    ingredientOutput[aroma] = checkAroma(aroma, aromaTypes, sharedAromaTypes);
  }); // fix chemical to Absent, concentrations are always very low, e.g. contamination from packaging etc. (cardboard)

  ingredientOutput[AromaType.Chemical] = AromaDotState.Absent;
  return ingredientOutput;
}
function checkAroma(aromaType, aromaTypes, sharedAromaTypes) {
  if (!(aromaTypes === null || aromaTypes === void 0 ? void 0 : aromaTypes.includes(aromaType))) {
    return AromaDotState.Absent;
  }

  return sharedAromaTypes.includes(aromaType) ? AromaDotState.ExistsShared : AromaDotState.ExistsNotShared;
}

const DotGraphViz = function DotGraphViz(_a) {
  const { aromaNamesColor } = _a;
  const { aromaNamesFontSize } = _a;
  const { exportBtnClassName } = _a;
  const { exportBtnTitle } = _a;
  const { main } = _a;
  const { other } = _a;
  const { showDownloadButton } = _a;
  const { showIngredientTitle } = _a;
  const { ingredientTitleColor } = _a;
  const { ingredientTitleFontSize } = _a;
  const { showAromaNames } = _a;
  const { svgWidth } = _a;
  const { wrapperClassName } = _a;
  const { wrapperWidth } = _a;
  const { forceDownload } = _a;
  let totalOffsetY = INITIAL_ROW_OFFSET_Y + CELL_WIDTH;
  const svgRef = React.useRef(null);
  const mainIngredient = React.useMemo(() => (main ? convertRowToIngredient(main, []) : null), [main]);
  const otherIngredients = React.useMemo(() => {
    if (!other.length || !main) {
      return [];
    }

    return other.map((ingredient) => {
      let _a;

      const sharedAromaTypes =
        (_a = ingredient === null || ingredient === void 0 ? void 0 : ingredient.aromaTypes) === null || _a === void 0
          ? void 0
          : _a.filter((value) => {
              let _a;

              const ingredientAromaMoleculeIds =
                (ingredient === null || ingredient === void 0 ? void 0 : ingredient.aromaTypeToMolecules[value]) || [];
              const mainAromaMoleculeIds =
                (main === null || main === void 0 ? void 0 : main.aromaTypeToMolecules[value]) || [];
              return !!((_a = mainAromaMoleculeIds.filter((id) => ingredientAromaMoleculeIds.includes(id))) === null ||
              _a === void 0
                ? void 0
                : _a.length);
            });
      return convertRowToIngredient(ingredient, sharedAromaTypes);
    });
  }, [other, main]);
  const height = React.useMemo(
    () => totalOffsetY + CELL_WIDTH * 2 + CELL_WIDTH * otherIngredients.length * 1.5,
    [otherIngredients.length],
  );
  const downloadSvg$1 = React.useCallback((e) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    downloadSvg(svgRef.current || '', 'dot-graph.svg');
  }, []);
  React.useEffect(() => {
    if (forceDownload) {
      downloadSvg$1(undefined);
    }
  }, [downloadSvg$1, forceDownload]);

  if (!mainIngredient) {
    return null;
  }

  return /* #__PURE__ */ React__default.default.createElement(
    'div',
    {
      className: wrapperClassName,
      style: {
        maxWidth: wrapperWidth,
      },
    },
    showDownloadButton &&
      /* #__PURE__ */ React__default.default.createElement(
        'button',
        {
          className: exportBtnClassName,
          type: 'button',
          onClick: downloadSvg$1,
        },
        exportBtnTitle,
      ),
    /* #__PURE__ */ React__default.default.createElement(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        ref: svgRef,
        viewBox: '0 0 '.concat(svgWidth, ' ').concat(height),
        width: svgWidth,
        height,
        style: {
          height: '100%',
        },
      },
      /* #__PURE__ */ React__default.default.createElement('defs', {
        xmlns: 'http://www.w3.org/2000/svg',
        id: 'genericDefs',
      }),
      showAromaNames &&
        /* #__PURE__ */ React__default.default.createElement(DotGraphVizTitleRow$1, {
          fontSize: aromaNamesFontSize,
          color: aromaNamesColor,
          cellWidth: CELL_WIDTH * 2 - 0.25,
          initialOffsetX: INITIAL_ROW_OFFSET_X,
          offsetY: INITIAL_ROW_OFFSET_Y,
        }),
      /* #__PURE__ */ React__default.default.createElement(DotGraphVizRow$1, {
        key: 'main',
        cellWidth: CELL_WIDTH * 2,
        ingredient: mainIngredient,
        initialOffsetX: INITIAL_ROW_OFFSET_X,
        fontSize: ingredientTitleFontSize,
        fontColor: ingredientTitleColor,
        offsetY: totalOffsetY,
        showIngredientTitle,
      }),
      otherIngredients.map((ingredient, idx) => {
        totalOffsetY += CELL_WIDTH * (idx === 0 ? 2 : 1.5);
        return /* #__PURE__ */ React__default.default.createElement(DotGraphVizRow$1, {
          key: ''.concat(ingredient.name, '_').concat(idx),
          cellWidth: CELL_WIDTH * 2,
          ingredient,
          initialOffsetX: INITIAL_ROW_OFFSET_X,
          offsetY: totalOffsetY,
          showIngredientTitle,
        });
      }),
    ),
  );
};

DotGraphViz.defaultProps = {
  exportBtnClassName: '',
  exportBtnTitle: 'Export to SVG',
  showAromaNames: false,
  showDownloadButton: false,
  showIngredientTitle: false,
  wrapperClassName: '',
  aromaNamesColor: undefined,
  aromaNamesFontSize: undefined,
  ingredientTitleColor: undefined,
  ingredientTitleFontSize: undefined,
};
const DotGraphViz$1 = /* #__PURE__ */ React.memo(DotGraphViz);

function passiveSupported(debug = false) {
  let passiveSupported = false;

  try {
    const options = Object.defineProperty({}, 'passive', {
      get() {
        passiveSupported = true;
      },
    });

    window.addEventListener('testPassive', null, options);
    window.removeEventListener('testPassive', null, options);
  } catch (error) {}

  if (debug) {
    const message = `[Passive Events Support] 'passive' option is ${
      !passiveSupported ? 'not ' : ''
    }supported by your browser.`;
    if (passiveSupported) console.info(message);
    else console.warn(message);
  }

  return passiveSupported;
}

function isEventSupported(event) {
  return ['touchstart', 'touchmove', 'touchenter', 'touchend', 'touchleave', 'wheel', 'mousewheel'].includes(event);
}

function passiveSupport(custom) {
  const options = {
    debug: false,
    events: [],
    listeners: [],
    ...custom,
  };

  if (options.debug) {
    console.info('[Passive Events Support] Initialized With', options);

    options.events = options.events.filter((event) => {
      const supported = isEventSupported(event);
      if (!supported) console.warn(`[Passive Events Support] Unsupported Event: ${event}`);
      return supported;
    });

    options.listeners = options.listeners.filter((listener) => {
      const supported = isEventSupported(listener.event);
      if (!supported) console.warn(`[Passive Events Support] Unsupported Listener:`, listener);
      return supported;
    });
  }

  const { debug, events, listeners } = options;
  const originalFn = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function (...args) {
    // check if it is non-passive
    const noPassiveOption = !args[2] || args[2].passive === undefined;

    if (isEventSupported(args[0]) && noPassiveOption) {
      // check if it should be updated
      const oldArguments = args[2];
      const isEventFromList = events.includes(args[0]);
      const isListenerFromList = listeners.find(
        ({ element, event }) => typeof this.matches === 'function' && this.matches(element) && event === args[0],
      );
      const shouldBeUpdated = isEventFromList || isListenerFromList;

      // check if it is prevented
      const fn = args[1].toString();
      const [fnDeclaration, ...fnContents] = fn.split('{');
      const fnName = fnDeclaration.replace(/(function|=>)/, '').trim();
      const fnContent = fnContents.join('{');
      const fnArgument = (fnName.match(/\(([^)]+)\)/) || [`(${fnName})`])[0].replace(/[()]/g, '');
      const fnPrevented = !!(
        fnContent.includes('preventDefault') ||
        (isListenerFromList && isListenerFromList.prevented)
      );

      // update arguments
      if (shouldBeUpdated) {
        args[2] = {
          ...(args[2] || {}),
          ...(passiveSupported() && { passive: !fnPrevented }),
        };
      }

      // console log the output
      if (debug) {
        console.info('[Passive Events Support] Non-passive Event Listener', {
          element: this,
          event: args[0],
          handler: {
            fn: args[1],
            fnArgument,
            fnContent,
            fnPrevented,
          },
          arguments: oldArguments,
          ...(shouldBeUpdated && { updatedArguments: args[2] }),
        });
      }
    }

    originalFn.call(this, ...args);
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  const { insertAt } = ref;

  if (!css || typeof document === 'undefined') {
    return;
  }

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

const css_248z = `div.visualization-wrapper-module_main-panel__1c-q6 {\n  height: 100%;\n  width: 100%; }\n\np.visualization-wrapper-module_main-version__2Dics {\n  top: .2rem;\n  right: 1rem;\n  font-family: 'Courier', serif;\n  font-size: 9px;\n  text-align: left;\n  position: fixed;\n  z-index: 1000; }\n\ncanvas.visualization-wrapper-module_main-view__2U0cx {\n  background-color: #ffffff;\n  border: 1px dotted;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: auto; }\n\ncanvas.visualization-wrapper-module_main-view__2U0cx[resize] {\n  width: 100%;\n  height: auto; }\n`;
const styles = {
  'main-panel': 'visualization-wrapper-module_main-panel__1c-q6',
  'main-version': 'visualization-wrapper-module_main-version__2Dics',
  'main-view': 'visualization-wrapper-module_main-view__2U0cx',
};
styleInject(css_248z);

passiveSupport({
  events: ['touchstart', 'touchmove'],
});

const VisualizationWrapper = function VisualizationWrapper(_a) {
  let _b;
  let _c;

  const { ingredient } = _a;
  const { taxonomy } = _a;
  const { canvasClassName } = _a;
  const { canvasPanelClassName } = _a;
  const { svgWrapperClassName } = _a;
  const { type } = _a;
  const { setRenderer } = _a;
  const { hidpi } = _a;
  const { width } = _a;
  const { height } = _a;
  const { useSvg } = _a;
  const { loading } = _a;
  const View = ViewMapping[type];

  const _d = React.useState(null);
  const renderer$1 = _d[0];
  const setMainRenderer = _d[1];

  const _e = React.useState(null);
  const svg = _e[0];
  const setSvg = _e[1];

  React.useEffect(() => {
    if (ingredient && taxonomy) {
      const mainPanel = document.getElementsByClassName(styles['main-panel'])[0];
      const mainRenderer = new renderer();

      if (mainPanel.childElementCount > 0) {
        mainPanel.removeChild(mainPanel.children[0]);
      }

      const viewParams = new views.ParameterView('Parameters', document.createElement('div'), 0, 0);
      const mainView = new View({
        id: styles['main-view'],
        parent: mainPanel,
        ingredient: new models.Ingredient(ingredient),
        taxonomy: new models.Taxonomy(taxonomy),
        className: ''.concat(styles['main-view'], ' ').concat(canvasClassName),
        hidpi,
      });
      viewParams.setHeight(height);
      viewParams.addObject(mainView);
      mainRenderer.attachView(mainView);
      setRenderer === null || setRenderer === void 0 ? void 0 : setRenderer(mainRenderer);
      setMainRenderer(mainRenderer);
    }
  }, [width, height, ingredient, taxonomy, type, loading]);
  React.useEffect(() => {
    let _a;
    let _b;
    let _c;

    const svgEl =
      (_a = renderer$1 === null || renderer$1 === void 0 ? void 0 : renderer$1.exportSVG) === null || _a === void 0
        ? void 0
        : _a.call(renderer$1);

    if (
      !((_c =
        (_b = renderer$1 === null || renderer$1 === void 0 ? void 0 : renderer$1.getProject) === null || _b === void 0
          ? void 0
          : _b.call(renderer$1)) === null || _c === void 0
        ? void 0
        : _c.isEmpty()) &&
      type &&
      width &&
      height &&
      (svgEl === null || svgEl === void 0 ? void 0 : svgEl.innerHTML)
    ) {
      setSvg(svgEl);
    }
  }, [
    width,
    height,
    type,
    (_c =
      (_b = renderer$1 === null || renderer$1 === void 0 ? void 0 : renderer$1.getProject) === null || _b === void 0
        ? void 0
        : _b.call(renderer$1)) === null || _c === void 0
      ? void 0
      : _c.isEmpty(),
    renderer$1,
    svg === null || svg === void 0 ? void 0 : svg.innerHTML,
    loading,
  ]);

  function getSvgHtml() {
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(svg ? svg.innerHTML : '', 'text/html');
    const bodyElement = parsedHTML.body;

    const createReactElement = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const attributes = Array.from(node.attributes).reduce((acc, attr) => {
          let attributeName = attr.name;
          if (attributeName.includes('-')) {
            attributeName = attributeName.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
          }
          if (attributeName === 'style') {
            const styles = attr.value.split(';').reduce((styleObj, style) => {
              const [property, value] = style.split(':');
              if (property && value) {
                let propertyName = property.trim();
                if (propertyName === 'mix-blend-mode') {
                  propertyName = 'mixBlendMode';
                }
                styleObj[propertyName] = value.trim();
              }
              return styleObj;
            }, {});
            acc.style = styles;
          } else {
            acc[attributeName] = attr.value;
          }
          return acc;
        }, {});
        if (attributes.gradientunits) {
          attributes.gradientUnits = attributes.gradientunits;
          delete attributes.gradientunits;
        }
        if (attributes.fill && attributes.fill.startsWith('url')) {
          const gradientId = attributes.fill.match(/#([^\)"]+)/)[1];
          attributes.fill = `url(#${gradientId})`;
        }
        let tagName = node.tagName.toLowerCase(); // Convert tag name to lowercase
        if (tagName === 'radialgradient') {
          tagName = 'radialGradient';
        }
        if (tagName === 'lineargradient') {
          tagName = 'linearGradient';
        }
        const children = Array.from(node.childNodes).map(createReactElement);
        return React.createElement(tagName, attributes, ...children);
      }
    };

    const reactElement = createReactElement(bodyElement);
    return reactElement.props.children;
  }

  return /* #__PURE__ */ React__default.default.createElement(
    'div',
    null,
    /* #__PURE__ */ React__default.default.createElement('div', {
      className: ''.concat(styles['main-panel'], ' ').concat(canvasPanelClassName),
    }),
    useSvg &&
      /* #__PURE__ */ React__default.default.createElement(
        'div',
        {
          className: svgWrapperClassName,
        },
        /* #__PURE__ */ React__default.default.createElement(
          'svg',
          {
            width: Number(width),
            preserveAspectRatio: 'xMidYMid meet',
            viewBox: (svg === null || svg === void 0 ? void 0 : svg.getAttribute('viewBox')) || undefined,
            height: Number(height),
            className: ''.concat(svgWrapperClassName, ' ').concat(ingredient ? 'visible' : 'hidden'),
          },
          getSvgHtml(),
        ),
      ),
  );
};

VisualizationWrapper.defaultProps = {
  hidpi: 'off',
  canvasClassName: '',
  canvasPanelClassName: '',
  svgWrapperClassName: '',
  setRenderer: undefined,
  useSvg: false,
  loading: false,
};
const VisualizationWrapper$1 = /* #__PURE__ */ React.memo(VisualizationWrapper);

const ExportButton = function ExportButton(_a) {
  const { children } = _a;
  const { buttonClassName } = _a;
  const { fileName } = _a;
  const { type } = _a;
  const { renderer } = _a;
  const { quality } = _a;
  const linkRef = React.useRef(null);
  const exportHandler = React.useCallback(
    (e, linkRef) => {
      let _a;

      if (!(linkRef === null || linkRef === void 0 ? void 0 : linkRef.current)) {
        return;
      }

      if (type === 'svg') {
        e.preventDefault();
        downloadSvg(
          (_a = renderer === null || renderer === void 0 ? void 0 : renderer.exportSVG) === null || _a === void 0
            ? void 0
            : _a.call(renderer),
          fileName,
        );
      }
    },
    [quality, type, fileName, renderer],
  );
  return /* #__PURE__ */ React__default.default.createElement(
    React__default.default.Fragment,
    null,
    /* #__PURE__ */ React__default.default.createElement(
      'div',
      {
        className: buttonClassName,
        onClick: function onClick(e) {
          return exportHandler(e, linkRef);
        },
      },
      children,
    ),
    /* #__PURE__ */ React__default.default.createElement('a', {
      href: '#',
      ref: linkRef,
    }),
  );
};

ExportButton.defaultProps = {
  quality: 1,
};

const Fruity = '#FFB600';
const Citrus = '#CEDC2F';
const Floral = '#941C81';
const Green = '#009C4A';
const Herbal = '#377F8F';
const Vegetable = '#8DC63F';
const Caramel = '#DC6A02';
const Roasted = '#673325';
const Nutty = '#D4A614';
const Woody = '#9E4915';
const Spicy = '#EF4123';
const Cheesy = '#FFCB05';
const Animal = '#AD274E';
const Chemical = '#555951';
const categoryColors__original = {
  Fruity,
  Citrus,
  Floral,
  Green,
  Herbal,
  Vegetable,
  Caramel,
  Roasted,
  Nutty,
  Woody,
  Spicy,
  Cheesy,
  Animal,
  Chemical,
};

const textFont = 'Helvetica Neue Medium';
const textColor = '#666666';
const inactiveColor = '#eeeeee';
const rotationInDegrees = -90;
const categoryHeight = 4;
const categoryRadius = 120;
const categoryTextSize = 14;
const categoryTextSpacer = 7;
const descriptorHeightIsVariable = true;
const descriptorHeightAnchor = 'inner';
const descriptorHeightFixed = 10;
const descriptorHeightMaximum = 32;
const descriptorHeightMinimum = 4;
const descriptorRadiusInner = 240;
const descriptorRadiusOuter = 480;
const descriptorSpacerInDegrees = 1;
const descriptorTextSizeMaximum = 16;
const descriptorTextSizeMinimum = 10;
const descriptorTextSpacer = 6;
const gradientIsVisible = true;
const gradientCurveWeight = 0.5;
const gradientOpacityIsVariable = true;
const gradientOpacityInner = 0.1;
const gradientOpacityOuter = 0.5;
const totalDegrees = 360;
const defaultV2ViewValues__original = {
  textFont,
  textColor,
  inactiveColor,
  rotationInDegrees,
  categoryHeight,
  categoryRadius,
  categoryTextSize,
  categoryTextSpacer,
  descriptorHeightIsVariable,
  descriptorHeightAnchor,
  descriptorHeightFixed,
  descriptorHeightMaximum,
  descriptorHeightMinimum,
  descriptorRadiusInner,
  descriptorRadiusOuter,
  descriptorSpacerInDegrees,
  descriptorTextSizeMaximum,
  descriptorTextSizeMinimum,
  descriptorTextSpacer,
  gradientIsVisible,
  gradientCurveWeight,
  gradientOpacityIsVariable,
  gradientOpacityInner,
  gradientOpacityOuter,
  totalDegrees,
};

const index = /* #__PURE__ */ Object.freeze({
  __proto__: null,
  categoryColors,
  categoryColors__original,
  defaultV2ViewValues,
  defaultV2ViewValuesOriginal: defaultV2ViewValues__original,
  fontMetrics,
  ingredient: ingredientJSON,
  taxonomy: taxonomyJSON,
});

if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined) {
  const origMethod_1 = console.assert;

  console.assert = function (condition) {
    let _a;

    const data = [];

    for (let _i = 1; _i < arguments.length; _i++) {
      data[_i - 1] = arguments[_i];
    }

    if (
      !((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0
        ? void 0
        : _a.includes('but instead got:'))
    ) {
      origMethod_1.apply(void 0, __spreadArray([condition], data));
    }
  };
}

export { AromaColorMapping };
export { AromaDotStateSizeMapping };
export { AromaTypesArray };
export { AromaType };
export { AromaDotState };
export { DotGraphViz$1 as DotGraphViz };
export { DotGraphVizRow$1 as DotGraphVizRow };
export { DotGraphVizTitleRow$1 as DotGraphVizTitleRow };
export { ExportButton };
export { VisualizationWrapper$1 as VisualizationWrapperComponent };
export { calculateTextWidth };
export { checkAroma };
export { convertRowToIngredient };
export { getDotProperty };
export { index as mockData };
export { index$1 as scripts };
